/* jshint esversion: 6 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import secureLocalStorage from 'react-secure-storage';

const resources = {
  en: {
    translation: {
      "Welcome Back": "Welcome Back",
      "to": "to",
      "GoMechPro": "GoMechPro",
      "Hello there, login to continue": "Hello there, login to continue",
      "Mobile Number": "Mobile Number",
      "Enter your mobile number...": "Enter your mobile number...",
      "Password": "Password",
      "Remember me": "Remember me",
      "Forget Password?": "Forget Password?",
      "Sign In": "Sign In",
      "Continue as Guest": "Continue as Guest",
      "Sign Up": "Sign Up",
      "Forgot Password?": "Forgot Password?",
      "Enter your mobile number account to": "Enter your mobile number account to",
      "reset your password.": "reset your password.",
      "Reset password": "Reset password",
      "Remember password?": "Remember password?",
      "OTP Code Verification": "OTP Code Verification",
      "We have sent an OTP code to your mobile": "We have sent an OTP code to your mobile",
      "number": "number",
      "Your OTP": "Your OTP",
      "Confirm": "Confirm",
      "Create New Password": "Create New Password",
      "Create your new password": "Create your new password",
      "Password strength": "Password strength",
      "Confirm New Password": "Confirm New Password",
      "Don't have and account?": "Don't have and account?",
      "Enter your password...": "Enter your password...",
      "input your password": "input your password",
      "Please enter details !!": "Please enter details !!",
      "Please enter mobile number !!": "Please enter mobile number !!",
      "OTP send successfully !!": "OTP send successfully !!",
      "OTP is invalid !!": "OTP is invalid !!",
      "Passwoed not match !!": "Passwoed not match !!",
      "Weak": "Weak",
      "Fair": "Fair",
      "Great ✅": "Great ✅",
      "Very Great ✅": "Very Great ✅",
      "Please enter valid email !!": "Please enter valid email !!",
      "Signup Account": "Signup Account",
      "Hello there, signup to continue": "Hello there, signup to continue",
      "Full Name": "Full Name",
      "Email Address": "Email Address",
      "Referral code": "Referral code",
      "I agree to the": "I agree to the",
      "Terms & Conditions & Privacy policy": "Terms & Conditions & Privacy policy",
      "Create Account": "Create Account",
      "I already have an account": "I already have an account",
      "Enter your full name...": "Enter your full name...",
      "Enter your email Address...": "Enter your email Address...",
      "Enter your referral code (Optional)": "Enter your referral code (Optional)",
      "Select Your Vehicle": "Select Your Vehicle",
      "Select Your Vehicle Brand": "Select Your Vehicle Brand",
      "No brand found for": "No brand found for",
      "this category": "this category",
      "Select Your": "Select Your",
      "Model": "Model",
      "No model found for": "No model found for",
      "this brand": "this brand",
      "Menu": "Menu",
      "Wallet": "Wallet",
      "Edit Profile": "Edit Profile",
      "My Order": "My Order",
      "Refer and Earn": "Refer and Earn",
      "Language": "Language",
      "Select Store": "Select Store",
      "No Stores found for": "No Stores found for",
      "this category.": "this category.",
      "Select Your Vehicle Details": "Select Your Vehicle Details",
      "Register Number": "Register Number",
      "Car Transmission Type": "Car Transmission Type",
      "Car Fuel Type": "Car Fuel Type",
      "Petrol": "Petrol",
      "Diesel": "Diesel",
      "CNG": "CNG",
      "Add Vehicle": "Add Vehicle",
      "Manual": "Manual",
      "Automatic": "Automatic",
      "Enter Your Register Number...": "Enter Your Register Number...",
      "Select Vehicle": "Select Vehicle",
      "Add New Vehicle +": "Add New Vehicle +",
      "Log Out": "Log Out",
      "Categories": "Categories",
      "Curated Custom Services": "Curated Custom Services",
      "Designer Service Combos": "Designer Service Combos",
      "GoMechanic Guarantee": "GoMechanic Guarantee",
      "OFF": "OFF",
      "ADDED": "ADDED",
      "ADD": "ADD",
      "Please Select All Details !!": "Please Select All Details !!",
      "Basic Service": "Basic Service",
      "Select Engine oil": "Select Engine oil",
      "Free": "Free",
      "Boost Your Service": "Boost Your Service",
      "For better performance & mileage": "For better performance & mileage",
      "ADD TO CART": "ADD TO CART",
      "Service Added": "Service Added",
      "VIEW CART": "VIEW CART",
      "Edit": "Edit",
      "Add Ons": "Add Ons",
      "Home": "Home",
      "Category Details": "Category Details",
      "My Cart": "My Cart",
      "Pay from Wallet": "Pay from Wallet",
      "My Wallet": "My Wallet",
      "Apply Coupon": "Apply Coupon",
      "Bill Summary": "Bill Summary",
      "Item Total (Incl. of taxes)": "Item Total (Incl. of taxes)",
      "Coupon Amount": "Coupon Amount",
      "Safety Fees": "Safety Fees",
      "Total Pay": "Total Pay",
      "Wallet Amount": "Wallet Amount",
      "Remove": "Remove",
      "Apply": "Apply",
      "View All Coupons": "View All Coupons",
      "Any other requirements...": "Any other requirements...",
      "Mode of service :": "Mode of service :",
      "Select Date Of Service :": "Select Date Of Service :",
      "Select Time Of Service :": "Select Time Of Service :",
      "Select Address :": "Select Address :",
      "+ Select Address": "+ Select Address",
      "Continue": "Continue",
      "Pickup": "Pickup",
      "Walk In": "Walk In",
      "Coupon Code :": "Coupon Code :",
      "Coupon Amount :": "Coupon Amount :",
      "Minimum Amount :": "Minimum Amount :",
      "Ex Date :": "Ex Date :",
      "Add Address": "Add Address",
      "Name": "Name",
      "Number": "Number",
      "House No": "House No",
      "Pincode": "Pincode",
      "Landmark": "Landmark",
      "Eg:Home, Office, Other...": "Eg:Home, Office, Other...",
      "Choose Address": "Choose Address",
      "+ Add Address": "+ Add Address",
      "Save address as": "Save address as",
      "Total Balance": "Total Balance",
      "Top Up": "Top Up",
      "Transaction": "Transaction",
      "No Any Transaction History !!": "No Any Transaction History !!",
      "Orders": "Orders",
      "You added": "You added",
      "items to orders": "items to orders",
      "SLOT SELECTED": "SLOT SELECTED",
      "STATUS": "STATUS",
      "No any bookings history !!": "No any bookings history !!",
      "Order Details": "Order Details",
      "Order Status": "Order Status",
      "Order Date": "Order Date",
      "Order Time": "Order Time",
      "Payment Method": "Payment Method",
      "Online": "Online",
      "Online & Wallet": "Online & Wallet",
      "Cash & Wallet": "Cash & Wallet",
      "Cash": "Cash",
      "Show More...": "Show More...",
      "Bill Summery": "Bill Summery",
      "Total": "Total",
      "Services": "Services",
      "DETAILS": "DETAILS",
      "Eran": "Eran",
      "for Each Friend you refer": "for Each Friend you refer",
      "Share the referral link with your friends": "Share the referral link with your friends",
      "Friend get": "Friend get",
      "on first complete transaction": "on first complete transaction",
      "You get": "You get",
      "on your wallet": "on your wallet",
      "Text copied to clipboard !!": "Text copied to clipboard !!",
      "Please enter detaisl !!": "Please enter detaisl !!",
      "Logout successfuly": "Logout successfuly",
      "Please Enter Details !!": "Please Enter Details !!",
      "Please Select Services !!": "Please Select Services !!",
      "Please Select Date !!": "Please Select Date !!",
      "Please Select Time !!": "Please Select Time !!",
      "Please Select Address !!": "Please Select Address !!",
      "Payment Faild !!": "Payment Faild !!",
      "Please Enter Name !!": "Please Enter Name !!",
      "Please Enter Email !!": "Please Enter Email !!",
      "Please Enter Valid Email !!": "Please Enter Valid Email !!",
      "Please Enter Password !!": "Please Enter Password !!",
      "Accessorie": "Accessorie",
      "Show Less": "Show Less",
      "Show More": "Show More",
      "What's Included": "What's Included",
      "Essential Services": "Essential Services",
      "Additional Service": "Additional Service",
      "Frequently Asked Questions": "Frequently Asked Questions",
      "Book Date": "Book Date",
      "Order id": "Order id",
      "Mode": "Mode",
      "Transaction id": "Transaction id",
      "Addition Note": "Addition Note",
      "Store Address": "Store Address",
      "Phone Number": "Phone Number",
      "Update": "Update",
      "Enter your mobile number": "Enter your mobile number",
      "Please Enter Amount !!": "Please Enter Amount !!",
      "Select Payment Methode !!": "Select Payment Methode !!",
      "Add Wallet Amount": "Add Wallet Amount",
      "Select Payment Methode": "Select Payment Methode",
      "Enter Amount": "Enter Amount",
      "Search Services": "Search Services",
      "Accessories": "Accessories",
      "Search service": "Search service",
      "Search Data !!": "Search Data !!",
      "Page Not Found": "Page Not Found",
      "Sorry, the page you are looking for does not exist.": "Sorry, the page you are looking for does not exist.",
      "To provide accurate services, please enable your location.": "To provide accurate services, please enable your location.",
      "Allow location access when prompted. If not prompted, enable it in your browser settings.": "Allow location access when prompted. If not prompted, enable it in your browser settings.",
      "Refresh the page after enabling.": "Refresh the page after enabling.",
      "Enable Now": "Enable Now",
      "Address": "Address",
      "Quantity": "Quantity",
      "Extra Charge": "Extra Charge",
      "Total Extra Charge": "Total Extra Charge",
      "Charge Payment Id": "Charge Payment Id",
      "Charge Transaction Id": "Charge Transaction Id",
      "Charge Status": "Charge Status",
      "Pay Extra Charge": "Pay Extra Charge",
      "Item Total": "Item Total",
      "Unpaid": "Unpaid",
      "Paid": "Paid",
      "Service ID": "Service ID",
      "Please select user !!": "Please select user !!",
      "Please write message !!": "Please write message !!",
      "Order History": "Order History",
      "User not found !!": "User not found !!",
      "Select user": "Select user",
      "Chat list not found !!": "Chat list not found !!",
      "Review": "Review",
      "Write message here...": "Write message here...",
      "No service history found !!": "No service history found !!",
      "Chat": "Chat",
      "Card number": "Card number",
      "Expiration date": "Expiration date",
      "CVC": "CVC",
      "Added in": "Added in",
      "Carts": "Carts",
    }
  },
  sp: {
    translation: {
      "Welcome Back": "Bienvenido de nuevo",
      "to": "a",
      "GoMechPro": "GoMechPro",
      "Hello there, login to continue": "Hola, inicia sesión para continuar",
      "Mobile Number": "Número de móvil",
      "Enter your mobile number...": "Introduce tu número de móvil...",
      "Password": "Contraseña",
      "Remember me": "Recuérdame",
      "Forget Password?": "¿Olvidaste la contraseña?",
      "Sign In": "Iniciar sesión",
      "Continue as Guest": "Continuar como invitado",
      "Sign Up": "Registrarse",
      "Forgot Password?": "¿Olvidaste la contraseña?",
      "Enter your mobile number account to": "Introduce tu número de móvil para",
      "reset your password.": "restablecer tu contraseña.",
      "Reset password": "Restablecer contraseña",
      "Remember password?": "¿Recordaste tu contraseña?",
      "OTP Code Verification": "Verificación de código OTP",
      "We have sent an OTP code to your mobile": "Hemos enviado un código OTP a tu móvil",
      "number": "número",
      "Your OTP": "Tu OTP",
      "Confirm": "Confirmar",
      "Create New Password": "Crear nueva contraseña",
      "Create your new password": "Crea tu nueva contraseña",
      "Password strength": "Fortaleza de la contraseña",
      "Confirm New Password": "Confirmar nueva contraseña",
      "Don't have and account?": "¿No tienes una cuenta?",
      "Enter your password...": "Introduce tu contraseña...",
      "input your password": "introduce tu contraseña",
      "Please enter details !!": "¡Por favor, introduce los datos!",
      "Please enter mobile number !!": "¡Por favor, introduce el número de móvil!",
      "OTP send successfully !!": "¡OTP enviado con éxito!",
      "OTP is invalid !!": "¡El OTP no es válido!",
      "Passwoed not match !!": "¡Las contraseñas no coinciden!",
      "Weak": "Débil",
      "Fair": "Aceptable",
      "Great ✅": "Genial ✅",
      "Very Great ✅": "Muy genial ✅",
      "Please enter valid email !!": "¡Por favor, introduce un correo válido!",
      "Signup Account": "Crear cuenta",
      "Hello there, signup to continue": "Hola, regístrate para continuar",
      "Full Name": "Nombre completo",
      "Email Address": "Dirección de correo",
      "Referral code": "Código de referido",
      "I agree to the": "Estoy de acuerdo con los",
      "Terms & Conditions & Privacy policy": "Términos y condiciones y política de privacidad",
      "Create Account": "Crear cuenta",
      "I already have an account": "Ya tengo una cuenta",
      "Enter your full name...": "Introduce tu nombre completo...",
      "Enter your email Address...": "Introduce tu correo electrónico...",
      "Enter your referral code (Optional)": "Introduce tu código de referido (opcional)",
      "Select Your Vehicle": "Selecciona tu vehículo",
      "Select Your Vehicle Brand": "Selecciona la marca de tu vehículo",
      "No brand found for": "No se encontró marca para",
      "this category": "esta categoría",
      "Select Your": "Selecciona tu",
      "Model": "Modelo",
      "No model found for": "No se encontró modelo para",
      "this brand": "esta marca",
      "Menu": "Menú",
      "Wallet": "Billetera",
      "Edit Profile": "Editar perfil",
      "My Order": "Mi pedido",
      "Refer and Earn": "Invita y gana",
      "Language": "Idioma",
      "Select Store": "Seleccionar tienda",
      "No Stores found for": "No se encontraron tiendas para",
      "this category.": "esta categoría.",
      "Select Your Vehicle Details": "Selecciona los detalles de tu vehículo",
      "Register Number": "Número de matrícula",
      "Car Transmission Type": "Tipo de transmisión",
      "Car Fuel Type": "Tipo de combustible",
      "Petrol": "Gasolina",
      "Diesel": "Diésel",
      "CNG": "GNC",
      "Add Vehicle": "Agregar vehículo",
      "Manual": "Manual",
      "Automatic": "Automático",
      "Enter Your Register Number...": "Introduce tu número de matrícula...",
      "Select Vehicle": "Seleccionar vehículo",
      "Add New Vehicle +": "Agregar nuevo vehículo +",
      "Log Out": "Cerrar sesión",
      "Categories": "Categorías",
      "Curated Custom Services": "Servicios personalizados seleccionados",
      "Designer Service Combos": "Combos de servicios diseñados",
      "GoMechanic Guarantee": "Garantía GoMechanic",
      "OFF": "DESCUENTO",
      "ADDED": "AGREGADO",
      "ADD": "AGREGAR",
      "Please Select All Details !!": "¡Por favor, selecciona todos los detalles!",
      "Basic Service": "Servicio básico",
      "Select Engine oil": "Seleccionar aceite de motor",
      "Free": "Gratis",
      "Boost Your Service": "Mejora tu servicio",
      "For better performance & mileage": "Para mejor rendimiento y kilometraje",
      "ADD TO CART": "AGREGAR AL CARRITO",
      "Service Added": "Servicio agregado",
      "VIEW CART": "VER CARRITO",
      "Edit": "Editar",
      "Add Ons": "Extras",
      "Home": "Inicio",
      "Category Details": "Detalles de la categoría",
      "My Cart": "Mi carrito",
      "Pay from Wallet": "Pagar desde la billetera",
      "My Wallet": "Mi billetera",
      "Apply Coupon": "Aplicar cupón",
      "Bill Summary": "Resumen de factura",
      "Item Total (Incl. of taxes)": "Total de artículos (incl. impuestos)",
      "Coupon Amount": "Monto del cupón",
      "Safety Fees": "Tarifas de seguridad",
      "Total Pay": "Pago total",
      "Wallet Amount": "Monto de la billetera",
      "Remove": "Eliminar",
      "Apply": "Aplicar",
      "View All Coupons": "Ver todos los cupones",
      "Any other requirements...": "¿Algún otro requisito?",
      "Mode of service :": "Modo de servicio:",
      "Select Date Of Service :": "Seleccionar fecha del servicio:",
      "Select Time Of Service :": "Seleccionar hora del servicio:",
      "Select Address :": "Seleccionar dirección:",
      "+ Select Address": "+ Seleccionar dirección",
      "Continue": "Continuar",
      "Pickup": "Recogida",
      "Walk In": "Visita en persona",
      "Coupon Code :": "Código de cupón:",
      "Coupon Amount :": "Monto del cupón:",
      "Minimum Amount :": "Monto mínimo:",
      "Ex Date :": "Fecha de expiración:",
      "Add Address": "Agregar dirección",
      "Name": "Nombre",
      "Number": "Número",
      "House No": "Número de casa",
      "Pincode": "Código postal",
      "Landmark": "Punto de referencia",
      "Eg:Home, Office, Other...": "Ej: Casa, Oficina, Otro...",
      "Choose Address": "Elegir dirección",
      "+ Add Address": "+ Agregar dirección",
      "Save address as": "Guardar dirección como",
      "Total Balance": "Saldo total",
      "Top Up": "Recargar",
      "Transaction": "Transacción",
      "No Any Transaction History !!": "¡No hay historial de transacciones!",
      "Orders": "Pedidos",
      "You added": "Has agregado",
      "items to orders": "artículos al pedido",
      "SLOT SELECTED": "RANGO HORARIO SELECCIONADO",
      "STATUS": "ESTADO",
      "No any bookings history !!": "¡No hay historial de reservas!",
      "Order Details": "Detalles del pedido",
      "Order Status": "Estado del pedido",
      "Order Date": "Fecha del pedido",
      "Order Time": "Hora del pedido",
      "Payment Method": "Método de pago",
      "Online": "En línea",
      "Online & Wallet": "En línea y billetera",
      "Cash & Wallet": "Efectivo y billetera",
      "Cash": "Efectivo",
      "Show More...": "Mostrar más...",
      "Bill Summery": "Resumen de factura",
      "Total": "Total",
      "Services": "Servicios",
      "DETAILS": "DETALLES",
      "Eran": "Gana",
      "for Each Friend you refer": "por cada amigo que refieras",
      "Share the referral link with your friends": "Comparte el enlace de referido con tus amigos",
      "Friend get": "Tu amigo recibe",
      "on first complete transaction": "en su primera transacción completada",
      "You get": "Tú recibes",
      "on your wallet": "en tu billetera",
      "Text copied to clipboard !!": "¡Texto copiado al portapapeles!",
      "Please enter detaisl !!": "¡Por favor, introduce los detalles!",
      "Logout successfuly": "Cierre de sesión exitoso",
      "Please Enter Details !!": "¡Por favor, introduce los detalles!",
      "Please Select Services !!": "¡Por favor, selecciona servicios!",
      "Please Select Date !!": "¡Por favor, selecciona la fecha!",
      "Please Select Time !!": "¡Por favor, selecciona la hora!",
      "Please Select Address !!": "¡Por favor, selecciona la dirección!",
      "Payment Faild !!": "¡Error en el pago!",
      "Please Enter Name !!": "¡Por favor, introduce el nombre!",
      "Please Enter Email !!": "¡Por favor, introduce el correo electrónico!",
      "Please Enter Valid Email !!": "¡Por favor, introduce un correo válido!",
      "Please Enter Password !!": "¡Por favor, introduce la contraseña!",
      "Accessorie": "Accesorio",
      "Show Less": "Mostrar menos",
      "Show More": "Mostrar más",
      "What's Included": "Qué está incluido",
      "Essential Services": "Servicios esenciales",
      "Additional Service": "Servicio adicional",
      "Frequently Asked Questions": "Preguntas frecuentes",
      "Book Date": "Fecha de reserva",
      "Order id": "ID de pedido",
      "Mode": "Modo",
      "Transaction id": "ID de transacción",
      "Addition Note": "Nota adicional",
      "Store Address": "Dirección de la tienda",
      "Phone Number": "Número de teléfono",
      "Update": "Actualizar",
      "Enter your mobile number": "Introduce tu número de móvil",
      "Please Enter Amount !!": "¡Por favor, introduce el monto!",
      "Select Payment Methode !!": "¡Selecciona el método de pago!",
      "Add Wallet Amount": "Agregar monto a la billetera",
      "Select Payment Methode": "Seleccionar método de pago",
      "Enter Amount": "Introduce el monto",
      "Search Services": "Buscar servicios",
      "Accessories": "Accesorios",
      "Search service": "Buscar servicio",
      "Search Data !!": "¡Buscar datos!",
      "Page Not Found": "Página no encontrada",
      "Sorry, the page you are looking for does not exist.": "Lo sentimos, la página que buscas no existe.",
      "To provide accurate services, please enable your location.": "Para proporcionar servicios precisos, habilita tu ubicación.",
      "Allow location access when prompted. If not prompted, enable it in your browser settings.": "Permite el acceso a la ubicación cuando se te solicite. Si no se te solicita, actívalo en la configuración del navegador.",
      "Refresh the page after enabling.": "Actualiza la página después de habilitarlo.",
      "Enable Now": "Habilitar ahora",
      "Address": "Dirección",
      "Quantity": "Cantidad",
      "Extra Charge": "Cargo Extra",
      "Total Extra Charge": "Cargo Extra Total",
      "Charge Payment Id": "ID de Pago del Cargo",
      "Charge Transaction Id": "ID de Transacción del Cargo",
      "Charge Status": "Estado del Cargo",
      "Pay Extra Charge": "Pagar Cargo Extra",
      "Item Total": "Total del Artículo",
      "Unpaid": "No Pagado",
      "Paid": "Pagado",
      "Service ID": "ID del Servicio",
      "Please select user !!": "¡Por favor seleccione un usuario!",
      "Please write message !!": "¡Por favor escriba un mensaje!",
      "Order History": "Historial de Pedidos",
      "User not found !!": "¡Usuario no encontrado!",
      "Select user": "Seleccionar usuario",
      "Chat list not found !!": "¡Lista de chat no encontrada!",
      "Review": "Reseña",
      "Write message here...": "Escribe un mensaje aquí...",
      "No service history found !!": "¡No se encontró historial de servicio!",
      "Chat": "Charla",
      "Card number": "Número de tarjeta",
      "Expiration date": "Fecha de vencimiento",
      "CVC": "CVC",
      "Added in": "Añadido en",
      "Carts": "Carritos"

    }
  },
  ar: {
    translation: {
      "Welcome Back": "مرحبًا بعودتك",
      "to": "إلى",
      "GoMechPro": "GoMechPro",
      "Hello there, login to continue": "مرحبًا، سجّل الدخول للمتابعة",
      "Mobile Number": "رقم الجوال",
      "Enter your mobile number...": "أدخل رقم جوالك...",
      "Password": "كلمة المرور",
      "Remember me": "تذكرني",
      "Forget Password?": "هل نسيت كلمة المرور؟",
      "Sign In": "تسجيل الدخول",
      "Continue as Guest": "المتابعة كضيف",
      "Sign Up": "إنشاء حساب",
      "Forgot Password?": "هل نسيت كلمة المرور؟",
      "Enter your mobile number account to": "أدخل رقم جوالك لـ",
      "reset your password.": "إعادة تعيين كلمة المرور.",
      "Reset password": "إعادة تعيين كلمة المرور",
      "Remember password?": "هل تتذكر كلمة المرور؟",
      "OTP Code Verification": "التحقق من رمز OTP",
      "We have sent an OTP code to your mobile": "أرسلنا رمز OTP إلى رقم جوالك",
      "number": "رقم",
      "Your OTP": "رمز OTP الخاص بك",
      "Confirm": "تأكيد",
      "Create New Password": "إنشاء كلمة مرور جديدة",
      "Create your new password": "أنشئ كلمة مرور جديدة",
      "Password strength": "قوة كلمة المرور",
      "Confirm New Password": "تأكيد كلمة المرور الجديدة",
      "Don't have and account?": "لا تملك حسابًا؟",
      "Enter your password...": "أدخل كلمة المرور...",
      "input your password": "أدخل كلمة المرور الخاصة بك",
      "Please enter details !!": "يرجى إدخال التفاصيل!",
      "Please enter mobile number !!": "يرجى إدخال رقم الجوال!",
      "OTP send successfully !!": "تم إرسال OTP بنجاح!",
      "OTP is invalid !!": "OTP غير صالح!",
      "Passwoed not match !!": "كلمة المرور غير متطابقة!",
      "Weak": "ضعيفة",
      "Fair": "متوسطة",
      "Great ✅": "قوية ✅",
      "Very Great ✅": "قوية جدًا ✅",
      "Please enter valid email !!": "يرجى إدخال بريد إلكتروني صالح!",
      "Signup Account": "إنشاء حساب",
      "Hello there, signup to continue": "مرحبًا، أنشئ حسابًا للمتابعة",
      "Full Name": "الاسم الكامل",
      "Email Address": "عنوان البريد الإلكتروني",
      "Referral code": "رمز الإحالة",
      "I agree to the": "أوافق على",
      "Terms & Conditions & Privacy policy": "الشروط والأحكام وسياسة الخصوصية",
      "Create Account": "إنشاء حساب",
      "I already have an account": "لدي حساب بالفعل",
      "Enter your full name...": "أدخل اسمك الكامل...",
      "Enter your email Address...": "أدخل بريدك الإلكتروني...",
      "Enter your referral code (Optional)": "أدخل رمز الإحالة (اختياري)",
      "Select Your Vehicle": "اختر سيارتك",
      "Select Your Vehicle Brand": "اختر ماركة سيارتك",
      "No brand found for": "لم يتم العثور على ماركة لـ",
      "this category": "هذا التصنيف",
      "Select Your": "اختر",
      "Model": "الطراز",
      "No model found for": "لم يتم العثور على طراز لـ",
      "this brand": "هذه الماركة",
      "Menu": "القائمة",
      "Wallet": "المحفظة",
      "Edit Profile": "تعديل الملف الشخصي",
      "My Order": "طلباتي",
      "Refer and Earn": "أحِل واربح",
      "Language": "اللغة",
      "Select Store": "اختر المتجر",
      "No Stores found for": "لم يتم العثور على متاجر لـ",
      "this category.": "هذا التصنيف.",
      "Select Your Vehicle Details": "اختر تفاصيل سيارتك",
      "Register Number": "رقم التسجيل",
      "Car Transmission Type": "نوع ناقل الحركة",
      "Car Fuel Type": "نوع الوقود",
      "Petrol": "بنزين",
      "Diesel": "ديزل",
      "CNG": "غاز طبيعي",
      "Add Vehicle": "إضافة سيارة",
      "Manual": "يدوي",
      "Automatic": "أوتوماتيك",
      "Enter Your Register Number...": "أدخل رقم التسجيل الخاص بك...",
      "Select Vehicle": "اختر السيارة",
      "Add New Vehicle +": "أضف سيارة جديدة +",
      "Log Out": "تسجيل الخروج",
      "Categories": "الفئات",
      "Curated Custom Services": "خدمات مخصصة مختارة",
      "Designer Service Combos": "حزم خدمات مصممة",
      "GoMechanic Guarantee": "ضمان GoMechanic",
      "OFF": "خصم",
      "ADDED": "مضاف",
      "ADD": "أضف",
      "Please Select All Details !!": "يرجى تحديد جميع التفاصيل!",
      "Basic Service": "الخدمة الأساسية",
      "Select Engine oil": "اختر زيت المحرك",
      "Free": "مجاني",
      "Boost Your Service": "عزز خدمتك",
      "For better performance & mileage": "لأداء أفضل واستهلاك أقل للوقود",
      "ADD TO CART": "أضف إلى السلة",
      "Service Added": "تمت إضافة الخدمة",
      "VIEW CART": "عرض السلة",
      "Edit": "تعديل",
      "Add Ons": "إضافات",
      "Home": "الرئيسية",
      "Category Details": "تفاصيل الفئة",
      "My Cart": "سلتي",
      "Pay from Wallet": "ادفع من المحفظة",
      "My Wallet": "محفظتي",
      "Apply Coupon": "تطبيق القسيمة",
      "Bill Summary": "ملخص الفاتورة",
      "Item Total (Incl. of taxes)": "إجمالي العناصر (شامل الضرائب)",
      "Coupon Amount": "قيمة القسيمة",
      "Safety Fees": "رسوم الأمان",
      "Total Pay": "الإجمالي المستحق",
      "Wallet Amount": "مبلغ المحفظة",
      "Remove": "إزالة",
      "Apply": "تطبيق",
      "View All Coupons": "عرض جميع القسائم",
      "Any other requirements...": "أي متطلبات أخرى...",
      "Mode of service :": "طريقة الخدمة:",
      "Select Date Of Service :": "اختر تاريخ الخدمة:",
      "Select Time Of Service :": "اختر وقت الخدمة:",
      "Select Address :": "اختر العنوان:",
      "+ Select Address": "+ اختر العنوان",
      "Continue": "متابعة",
      "Pickup": "استلام",
      "Walk In": "زيارة مباشرة",
      "Coupon Code :": "رمز القسيمة:",
      "Coupon Amount :": "قيمة القسيمة:",
      "Minimum Amount :": "الحد الأدنى للمبلغ:",
      "Ex Date :": "تاريخ الانتهاء:",
      "Add Address": "إضافة عنوان",
      "Name": "الاسم",
      "Number": "الرقم",
      "House No": "رقم المنزل",
      "Pincode": "الرمز البريدي",
      "Landmark": "علامة مميزة",
      "Eg:Home, Office, Other...": "مثال: المنزل، المكتب، آخر...",
      "Choose Address": "اختر العنوان",
      "+ Add Address": "+ أضف عنوانًا",
      "Save address as": "احفظ العنوان كـ",
      "Total Balance": "إجمالي الرصيد",
      "Top Up": "شحن",
      "Transaction": "معاملة",
      "No Any Transaction History !!": "لا يوجد سجل معاملات!",
      "Orders": "الطلبات",
      "You added": "لقد أضفت",
      "items to orders": "عنصرًا إلى الطلب",
      "SLOT SELECTED": "الفترة الزمنية المختارة",
      "STATUS": "الحالة",
      "No any bookings history !!": "لا يوجد سجل حجوزات!",
      "Order Details": "تفاصيل الطلب",
      "Order Status": "حالة الطلب",
      "Order Date": "تاريخ الطلب",
      "Order Time": "وقت الطلب",
      "Payment Method": "طريقة الدفع",
      "Online": "أونلاين",
      "Online & Wallet": "أونلاين ومحفظة",
      "Cash & Wallet": "نقدًا ومحفظة",
      "Cash": "نقدًا",
      "Show More...": "عرض المزيد...",
      "Bill Summery": "ملخص الفاتورة",
      "Total": "الإجمالي",
      "Services": "الخدمات",
      "DETAILS": "التفاصيل",
      "Eran": "اكسب",
      "for Each Friend you refer": "عن كل صديق تقوم بدعوته",
      "Share the referral link with your friends": "شارك رابط الدعوة مع أصدقائك",
      "Friend get": "الصديق يحصل على",
      "on first complete transaction": "عند أول معاملة مكتملة",
      "You get": "أنت تحصل على",
      "on your wallet": "في محفظتك",
      "Text copied to clipboard !!": "تم نسخ النص!",
      "Please enter detaisl !!": "يرجى إدخال التفاصيل!",
      "Logout successfuly": "تم تسجيل الخروج بنجاح",
      "Please Enter Details !!": "يرجى إدخال التفاصيل!",
      "Please Select Services !!": "يرجى اختيار الخدمات!",
      "Please Select Date !!": "يرجى اختيار التاريخ!",
      "Please Select Time !!": "يرجى اختيار الوقت!",
      "Please Select Address !!": "يرجى اختيار العنوان!",
      "Payment Faild !!": "فشل الدفع!",
      "Please Enter Name !!": "يرجى إدخال الاسم!",
      "Please Enter Email !!": "يرجى إدخال البريد الإلكتروني!",
      "Please Enter Valid Email !!": "يرجى إدخال بريد إلكتروني صحيح!",
      "Please Enter Password !!": "يرجى إدخال كلمة المرور!",
      "Accessorie": "ملحق",
      "Show Less": "عرض أقل",
      "Show More": "عرض المزيد",
      "What's Included": "ما الذي يتضمنه",
      "Essential Services": "الخدمات الأساسية",
      "Additional Service": "خدمة إضافية",
      "Frequently Asked Questions": "الأسئلة الشائعة",
      "Book Date": "تاريخ الحجز",
      "Order id": "رقم الطلب",
      "Mode": "الوضع",
      "Transaction id": "رقم المعاملة",
      "Addition Note": "ملاحظة إضافية",
      "Store Address": "عنوان المتجر",
      "Phone Number": "رقم الهاتف",
      "Update": "تحديث",
      "Enter your mobile number": "أدخل رقم هاتفك المحمول",
      "Please Enter Amount !!": "يرجى إدخال المبلغ!",
      "Select Payment Methode !!": "يرجى اختيار طريقة الدفع!",
      "Add Wallet Amount": "أضف مبلغًا إلى المحفظة",
      "Select Payment Methode": "اختر طريقة الدفع",
      "Enter Amount": "أدخل المبلغ",
      "Search Services": "البحث عن الخدمات",
      "Accessories": "الملحقات",
      "Search service": "البحث عن خدمة",
      "Search Data !!": "البحث عن بيانات!",
      "Page Not Found": "الصفحة غير موجودة",
      "Sorry, the page you are looking for does not exist.": "عذرًا، الصفحة التي تبحث عنها غير موجودة.",
      "To provide accurate services, please enable your location.": "لتحسين دقة الخدمات، يرجى تفعيل الموقع.",
      "Allow location access when prompted. If not prompted, enable it in your browser settings.": "اسمح بالوصول إلى الموقع عند الطلب. إذا لم يُطلب منك، فعّله من إعدادات المتصفح.",
      "Refresh the page after enabling.": "قم بتحديث الصفحة بعد التفعيل.",
      "Enable Now": "فعّل الآن",
      "Address": "العنوان",
      "Quantity": "الكمية",
      "Extra Charge": "رسوم إضافية",
      "Total Extra Charge": "إجمالي الرسوم الإضافية",
      "Charge Payment Id": "معرّف دفع الرسوم",
      "Charge Transaction Id": "معرّف معاملة الرسوم",
      "Charge Status": "حالة الرسوم",
      "Pay Extra Charge": "دفع الرسوم الإضافية",
      "Item Total": "إجمالي العناصر",
      "Unpaid": "غير مدفوع",
      "Paid": "مدفوع",
      "Service ID": "معرّف الخدمة",
      "Please select user !!": "يرجى اختيار المستخدم !!",
      "Please write message !!": "يرجى كتابة الرسالة !!",
      "Order History": "سجل الطلبات",
      "User not found !!": "المستخدم غير موجود !!",
      "Select user": "اختر المستخدم",
      "Chat list not found !!": "قائمة المحادثات غير موجودة !!",
      "Review": "مراجعة",
      "Write message here...": "اكتب الرسالة هنا...",
      "No service history found !!": "لم يتم العثور على سجل الخدمة!!",
      "Chat": "دردشة",
      "Card number": "رقم البطاقة",
      "Expiration date": "تاريخ الانتهاء",
      "CVC": "رمز التحقق (CVC)",
      "Added in": "أضيف في",
      "Carts": "عربات"

    }
  },
  hi: {
    translation: {
      "Welcome Back": "स्वागत है वापस",
      "to": "को",
      "GoMechPro": "GoMechPro",
      "Hello there, login to continue": "नमस्ते, जारी रखने के लिए लॉगिन करें",
      "Mobile Number": "मोबाइल नंबर",
      "Enter your mobile number...": "अपना मोबाइल नंबर दर्ज करें...",
      "Password": "पासवर्ड",
      "Remember me": "मुझे याद रखें",
      "Forget Password?": "पासवर्ड भूल गए?",
      "Sign In": "साइन इन करें",
      "Continue as Guest": "अतिथि के रूप में जारी रखें",
      "Sign Up": "साइन अप करें",
      "Forgot Password?": "पासवर्ड भूल गए?",
      "Enter your mobile number account to": "अपना मोबाइल नंबर खाता दर्ज करें",
      "reset your password.": "अपना पासवर्ड रीसेट करने के लिए।",
      "Reset password": "पासवर्ड रीसेट करें",
      "Remember password?": "पासवर्ड याद रखें?",
      "OTP Code Verification": "OTP कोड सत्यापन",
      "We have sent an OTP code to your mobile": "हमने आपके मोबाइल पर OTP कोड भेजा है",
      "number": "नंबर",
      "Your OTP": "आपका OTP",
      "Confirm": "पुष्टि करें",
      "Create New Password": "नया पासवर्ड बनाएं",
      "Create your new password": "अपना नया पासवर्ड बनाएं",
      "Password strength": "पासवर्ड की ताकत",
      "Confirm New Password": "नए पासवर्ड की पुष्टि करें",
      "Don't have an account?": "क्या आपका खाता नहीं है?",
      "Enter your password...": "अपना पासवर्ड दर्ज करें...",
      "Input your password": "अपना पासवर्ड डालें",
      "Please enter details !!": "कृपया विवरण दर्ज करें !!",
      "Please enter mobile number !!": "कृपया मोबाइल नंबर दर्ज करें !!",
      "OTP sent successfully !!": "OTP सफलतापूर्वक भेजा गया !!",
      "OTP is invalid !!": "OTP अमान्य है !!",
      "Password not match !!": "पासवर्ड मेल नहीं खा रहा है !!",
      "Weak": "कमज़ोर",
      "Fair": "संतोषजनक",
      "Great ✅": "उत्तम ✅",
      "Very Great ✅": "बहुत उत्तम ✅",
      "Please enter valid email !!": "कृपया मान्य ईमेल दर्ज करें !!",
      "Signup Account": "खाता साइनअप करें",
      "Hello there, signup to continue": "नमस्ते, जारी रखने के लिए साइनअप करें",
      "Full Name": "पूरा नाम",
      "Email Address": "ईमेल पता",
      "Referral code": "रेफरल कोड",
      "I agree to the": "मैं सहमत हूं",
      "Terms & Conditions & Privacy policy": "नियम और शर्तें और गोपनीयता नीति",
      "Create Account": "खाता बनाएं",
      "I already have an account": "मेरा पहले से एक खाता है",
      "Enter your full name...": "अपना पूरा नाम दर्ज करें...",
      "Enter your email Address...": "अपना ईमेल पता दर्ज करें...",
      "Enter your referral code (Optional)": "अपना रेफरल कोड दर्ज करें (वैकल्पिक)...",
      "Select Your Vehicle": "अपना वाहन चुनें",
      "Select Your Vehicle Brand": "अपने वाहन की ब्रांड चुनें",
      "No brand found for": "इसके लिए कोई ब्रांड नहीं मिली",
      "this category": "इस श्रेणी में",
      "Select Your": "अपना चयन करें",
      "Model": "मॉडल",
      "No model found for": "इसके लिए कोई मॉडल नहीं मिला",
      "this brand": "इस ब्रांड में",
      "Menu": "मेनू",
      "Wallet": "वॉलेट",
      "Edit Profile": "प्रोफ़ाइल संपादित करें",
      "My Order": "मेरा ऑर्डर",
      "Refer and Earn": "रेफ़र करें और कमाएँ",
      "Language": "भाषा",
      "Select Store": "स्टोर चुनें",
      "No Stores found for": "इसके लिए कोई स्टोर नहीं मिला",
      "this category.": "इस श्रेणी में।",
      "Select Your Vehicle Details": "अपने वाहन का विवरण चुनें",
      "Register Number": "रजिस्ट्रेशन नंबर",
      "Car Transmission Type": "कार ट्रांसमिशन प्रकार",
      "Car Fuel Type": "कार ईंधन प्रकार",
      "Petrol": "पेट्रोल",
      "Diesel": "डीज़ल",
      "CNG": "सीएनजी",
      "Add Vehicle": "वाहन जोड़ें",
      "Manual": "मैनुअल",
      "Automatic": "ऑटोमैटिक",
      "Enter Your Register Number...": "अपना रजिस्ट्रेशन नंबर दर्ज करें...",
      "Select Vehicle": "वाहन चुनें",
      "Add New Vehicle +": "नया वाहन जोड़ें +",
      "Log Out": "लॉग आउट",
      "Categories": "श्रेणियाँ",
      "Curated Custom Services": "विशेष रूप से तैयार की गई कस्टम सेवाएँ",
      "Designer Service Combos": "डिज़ाइनर सेवा कॉम्बो",
      "GoMechanic Guarantee": "गोमेकैनिक गारंटी",
      "OFF": "छूट",
      "ADDED": "जोड़ा गया",
      "ADD": "जोड़ें",
      "Please Select All Details !!": "कृपया सभी विवरण चुनें !!",
      "Basic Service": "बेसिक सेवा",
      "Select Engine oil": "इंजन ऑयल चुनें",
      "Free": "मुफ़्त",
      "Boost Your Service": "अपनी सेवा को बढ़ाएँ",
      "For better performance & mileage": "बेहतर परफॉर्मेंस और माइलेज के लिए",
      "ADD TO CART": "कार्ट में जोड़ें",
      "Service Added": "सेवा जोड़ी गई",
      "VIEW CART": "कार्ट देखें",
      "Edit": "संपादित करें",
      "Add Ons": "ऐड-ऑन्स",
      "Home": "होम",
      "Category Details": "श्रेणी विवरण",
      "My Cart": "मेरा कार्ट",
      "Pay from Wallet": "वॉलेट से भुगतान करें",
      "My Wallet": "मेरा वॉलेट",
      "Apply Coupon": "कूपन लागू करें",
      "Bill Summary": "बिल सारांश",
      "Item Total (Incl. of taxes)": "आइटम कुल (करों सहित)",
      "Coupon Amount": "कूपन राशि",
      "Safety Fees": "सुरक्षा शुल्क",
      "Total Pay": "कुल भुगतान",
      "Wallet Amount": "वॉलेट राशि",
      "Remove": "हटाएं",
      "Apply": "लागू करें",
      "View All Coupons": "सभी कूपन देखें",
      "Any other requirements...": "कोई अन्य आवश्यकताएँ...",
      "Mode of service :": "सेवा का तरीका :",
      "Select Date Of Service :": "सेवा की तिथि चुनें :",
      "Select Time Of Service :": "सेवा का समय चुनें :",
      "Select Address :": "पता चुनें :",
      "+ Select Address": "+ पता चुनें",
      "Continue": "जारी रखें",
      "Pickup": "पिकअप",
      "Walk In": "खुद आएं",
      "Coupon Code :": "कूपन कोड :",
      "Coupon Amount :": "कूपन राशि :",
      "Minimum Amount :": "न्यूनतम राशि :",
      "Ex Date :": "समाप्ति तिथि :",
      "Add Address": "पता जोड़ें",
      "Name": "नाम",
      "Number": "नंबर",
      "House No": "मकान नंबर",
      "Pincode": "पिनकोड",
      "Landmark": "सीमाचिह्न",
      "Eg:Home, Office, Other...": "जैसे: घर, कार्यालय, अन्य...",
      "Choose Address": "पता चुनें",
      "+ Add Address": "+ पता जोड़ें",
      "Save address as": "पते को इस नाम से सहेजें",
      "Total Balance": "कुल शेष राशि",
      "Top Up": "राशि जोड़ें",
      "Transaction": "लेन-देन",
      "No Any Transaction History !!": "कोई लेन-देन का इतिहास नहीं है !!",
      "Orders": "आदेश",
      "You added": "आपने जोड़ा",
      "items to orders": "आदेशों में आइटम जोड़े",
      "SLOT SELECTED": "स्लॉट चुना गया",
      "STATUS": "स्थिति",
      "No any bookings history !!": "कोई बुकिंग इतिहास नहीं है !!",
      "Order Details": "आदेश विवरण",
      "Order Status": "आदेश की स्थिति",
      "Order Date": "आदेश की तारीख",
      "Order Time": "आदेश का समय",
      "Payment Method": "भुगतान का तरीका",
      "Online": "ऑनलाइन",
      "Online & Wallet": "ऑनलाइन और वॉलेट",
      "Cash & Wallet": "नकद और वॉलेट",
      "Cash": "नकद",
      "Show More...": "और दिखाएं...",
      "Bill Summery": "बिल सारांश",
      "Total": "कुल",
      "Services": "सेवाएं",
      "DETAILS": "विवरण",
      "Eran": "कमाएँ",
      "for Each Friend you refer": "हर मित्र को रेफ़र करने पर",
      "Share the referral link with your friends": "अपने दोस्तों के साथ रेफ़रल लिंक साझा करें",
      "Friend get": "मित्र को मिलेगा",
      "on first complete transaction": "पहले पूर्ण लेनदेन पर",
      "You get": "आपको मिलेगा",
      "on your wallet": "आपके वॉलेट में",
      "Text copied to clipboard !!": "पाठ क्लिपबोर्ड पर कॉपी हो गया !!",
      "Please enter detaisl !!": "कृपया विवरण दर्ज करें !!",
      "Logout successfuly": "लॉगआउट सफल रहा",
      "Please Enter Details !!": "कृपया विवरण दर्ज करें !!",
      "Please Select Services !!": "कृपया सेवाएं चुनें !!",
      "Please Select Date !!": "कृपया तिथि चुनें !!",
      "Please Select Time !!": "कृपया समय चुनें !!",
      "Please Select Address !!": "कृपया पता चुनें !!",
      "Payment Faild !!": "भुगतान विफल हुआ !!",
      "Please Enter Name !!": "कृपया नाम दर्ज करें !!",
      "Please Enter Email !!": "कृपया ईमेल दर्ज करें !!",
      "Please Enter Valid Email !!": "कृपया मान्य ईमेल दर्ज करें !!",
      "Please Enter Password !!": "कृपया पासवर्ड दर्ज करें !!",
      "Accessorie": "एक्सेसरी",
      "Show Less": "कम दिखाएं",
      "Show More": "और दिखाएं",
      "What's Included": "क्या शामिल है",
      "Essential Services": "आवश्यक सेवाएं",
      "Additional Service": "अतिरिक्त सेवा",
      "Frequently Asked Questions": "अक्सर पूछे जाने वाले प्रश्न",
      "Book Date": "बुक तिथि",
      "Order id": "ऑर्डर आईडी",
      "Mode": "मोड",
      "Transaction id": "लेन-देन आईडी",
      "Addition Note": "अतिरिक्त नोट",
      "Store Address": "स्टोर पता",
      "Phone Number": "फोन नंबर",
      "Update": "अपडेट",
      "Enter your mobile number": "अपना मोबाइल नंबर दर्ज करें",
      "Please Enter Amount !!": "कृपया राशि दर्ज करें !!",
      "Select Payment Methode !!": "कृपया भुगतान विधि चुनें !!",
      "Add Wallet Amount": "वॉलेट राशि जोड़ें",
      "Select Payment Methode": "भुगतान विधि चुनें",
      "Enter Amount": "राशि दर्ज करें",
      "Search Services": "सेवाएं खोजें",
      "Accessories": "एक्सेसरीज़",
      "Search service": "सेवा खोजें",
      "Search Data !!": "डेटा खोजें !!",
      "Page Not Found": "पृष्ठ नहीं मिला",
      "Sorry, the page you are looking for does not exist.": "माफ़ कीजिए, जिस पृष्ठ को आप ढूंढ रहे हैं वह मौजूद नहीं है।",
      "To provide accurate services, please enable your location.": "सटीक सेवाएं प्रदान करने के लिए, कृपया अपनी लोकेशन चालू करें।",
      "Allow location access when prompted. If not prompted, enable it in your browser settings.": "जब अनुरोध किया जाए तो लोकेशन एक्सेस की अनुमति दें। यदि अनुरोध नहीं किया जाए, तो ब्राउज़र सेटिंग्स में इसे सक्षम करें।",
      "Refresh the page after enabling.": "सक्षम करने के बाद पेज को रीफ़्रेश करें।",
      "Enable Now": "अभी सक्षम करें",
      "Address": "पता",
      "Quantity": "मात्रा",
      "Extra Charge": "अतिरिक्त शुल्क",
      "Total Extra Charge": "कुल अतिरिक्त शुल्क",
      "Charge Payment Id": "शुल्क भुगतान आईडी",
      "Charge Transaction Id": "शुल्क लेन-देन आईडी",
      "Charge Status": "शुल्क स्थिति",
      "Pay Extra Charge": "अतिरिक्त शुल्क का भुगतान करें",
      "Item Total": "कुल आइटम",
      "Unpaid": "अवैतनिक",
      "Paid": "भुगतान किया गया",
      "Service ID": "सेवा आईडी",
      "Please select user !!": "कृपया उपयोगकर्ता चुनें !!",
      "Please write message !!": "कृपया संदेश लिखें !!",
      "Order History": "आदेश इतिहास",
      "User not found !!": "उपयोगकर्ता नहीं मिला !!",
      "Select user": "उपयोगकर्ता चुनें",
      "Chat list not found !!": "चैट सूची नहीं मिली !!",
      "Review": "समीक्षा",
      "Write message here...": "यहाँ संदेश लिखें...",
      "No service history found !!": "कोई सेवा इतिहास नहीं मिला !!",
      "Chat": "चैट",
      "Card number": "कार्ड नंबर",
      "Expiration date": "समाप्ति तिथि",
      "CVC": "सीवीसी",
      "Added in": "जोड़ा गया",
      "Carts": "गाड़ियाँ"

    }
  },
  gu: {
    translation: {
      "Welcome Back": "પાછા આવવા માટે આપનું સ્વાગત છે",
      "to": "માં",
      "GoMechPro": "GoMechPro",
      "Hello there, login to continue": "હેલો, ચાલુ રાખવા માટે લોગિન કરો",
      "Mobile Number": "મોબાઇલ નંબર",
      "Enter your mobile number...": "તમારું મોબાઇલ નંબર દાખલ કરો...",
      "Password": "પાસવર્ડ",
      "Remember me": "મને યાદ રાખો",
      "Forget Password?": "પાસવર્ડ ભૂલ્યા?",
      "Sign In": "સાઇન ઇન",
      "Continue as Guest": "મહેમાન તરીકે ચાલુ રાખો",
      "Sign Up": "સાઇન અપ",
      "Forgot Password?": "પાસવર્ડ ભૂલાઈ ગયો?",
      "Enter your mobile number account to": "તમારું મોબાઇલ નંબર દાખલ કરો",
      "reset your password.": "તમારો પાસવર્ડ રીસેટ કરવા માટે.",
      "Reset password": "પાસવર્ડ રીસેટ કરો",
      "Remember password?": "પાસવર્ડ યાદ છે?",
      "OTP Code Verification": "OTP કોડ ચકાસણી",
      "We have sent an OTP code to your mobile": "અમે તમારાં મોબાઇલ પર OTP કોડ મોકલ્યો છે",
      "number": "નંબર",
      "Your OTP": "તમારું OTP",
      "Confirm": "ખાતરી કરો",
      "Create New Password": "નવું પાસવર્ડ બનાવો",
      "Create your new password": "તમારું નવું પાસવર્ડ બનાવો",
      "Password strength": "પાસવર્ડની શક્તિ",
      "Confirm New Password": "નવું પાસવર્ડ પુષ્ટિ કરો",
      "Don't have and account?": "એકાઉન્ટ નથી?",
      "Enter your password...": "તમારું પાસવર્ડ દાખલ કરો...",
      "input your password": "તમારું પાસવર્ડ નાખો",
      "Please enter details !!": "કૃપા કરીને વિગતો દાખલ કરો !!",
      "Please enter mobile number !!": "કૃપા કરીને મોબાઇલ નંબર દાખલ કરો !!",
      "OTP send successfully !!": "OTP સફળતાપૂર્વક મોકલાયો !!",
      "OTP is invalid !!": "OTP અમાન્ય છે !!",
      "Passwoed not match !!": "પાસવર્ડ મેળ ખાતો નથી !!",
      "Weak": "નબળું",
      "Fair": "મધ્યમ",
      "Great ✅": "સારો ✅",
      "Very Great ✅": "ખૂબ જ સારો ✅",
      "Please enter valid email !!": "કૃપા કરીને માન્ય ઈમેઈલ દાખલ કરો !!",
      "Signup Account": "ખાતું સાઇનઅપ કરો",
      "Hello there, signup to continue": "હેલો, ચાલુ રાખવા માટે સાઇનઅપ કરો",
      "Full Name": "પૂર્ણ નામ",
      "Email Address": "ઈમેઈલ સરનામું",
      "Referral code": "રેફરલ કોડ",
      "I agree to the": "હું સંમત છું",
      "Terms & Conditions & Privacy policy": "શરતો અને નિયમો અને ગોપનીયતા નીતિ",
      "Create Account": "ખાતું બનાવો",
      "I already have an account": "મારું પહેલેથી એકાઉન્ટ છે",
      "Enter your full name...": "તમારું પૂરું નામ દાખલ કરો...",
      "Enter your email Address...": "તમારું ઈમેઈલ સરનામું દાખલ કરો...",
      "Enter your referral code (Optional)": "તમારું રેફરલ કોડ દાખલ કરો (વૈકલ્પિક)",
      "Select Your Vehicle": "તમારું વાહન પસંદ કરો",
      "Select Your Vehicle Brand": "તમારું વાહન બ્રાન્ડ પસંદ કરો",
      "No brand found for": "આ માટે કોઈ બ્રાન્ડ મળી નથી",
      "this category": "આ શ્રેણી",
      "Select Your": "પસંદ કરો",
      "Model": "મોડેલ",
      "No model found for": "આ બ્રાન્ડ માટે કોઈ મોડેલ મળ્યું નથી",
      "this brand": "આ બ્રાન્ડ",
      "Menu": "મેનૂ",
      "Wallet": "વૉલેટ",
      "Edit Profile": "પ્રોફાઇલ સંપાદિત કરો",
      "My Order": "મારા ઓર્ડર",
      "Refer and Earn": "ભલામણ કરો અને કમાઓ",
      "Language": "ભાષા",
      "Select Store": "સ્ટોર પસંદ કરો",
      "No Stores found for": "આ માટે કોઈ સ્ટોર મળ્યું નથી",
      "this category.": "આ શ્રેણી.",
      "Select Your Vehicle Details": "તમારા વાહનની વિગતો પસંદ કરો",
      "Register Number": "રજિસ્ટર નંબર",
      "Car Transmission Type": "કારનું ટ્રાન્સમિશન પ્રકાર",
      "Car Fuel Type": "કાર ફ્યુઅલ પ્રકાર",
      "Petrol": "પેટ્રોલ",
      "Diesel": "ડિઝલ",
      "CNG": "સીએનજી",
      "Add Vehicle": "વાહન ઉમેરો",
      "Manual": "મેન્યુઅલ",
      "Automatic": "ઓટોમેટિક",
      "Enter Your Register Number...": "તમારું રજિસ્ટર નંબર દાખલ કરો...",
      "Select Vehicle": "વાહન પસંદ કરો",
      "Add New Vehicle +": "નવું વાહન ઉમેરો +",
      "Log Out": "લૉગ આઉટ",
      "Categories": "શ્રેણીઓ",
      "Curated Custom Services": "કસ્ટમ સેવાઓ",
      "Designer Service Combos": "ડિઝાઇનર સેવા કોમ્બો",
      "GoMechanic Guarantee": "GoMechanic ગેરંટી",
      "OFF": "બંધ",
      "ADDED": "ઉમેરાયું",
      "ADD": "ઉમેરો",
      "Please Select All Details !!": "કૃપા કરીને તમામ વિગતો પસંદ કરો !!",
      "Basic Service": "મૂળભૂત સેવા",
      "Select Engine oil": "એન્જિન ઓઈલ પસંદ કરો",
      "Free": "મફત",
      "Boost Your Service": "તમારી સેવા વધારો",
      "For better performance & mileage": "સારા પ્રદર્શન અને માઈલેજ માટે",
      "ADD TO CART": "કાર્ટમાં ઉમેરો",
      "Service Added": "સેવા ઉમેરાઈ ગઈ",
      "VIEW CART": "કાર્ટ જુઓ",
      "Edit": "સંપાદન",
      "Add Ons": "એડ ઑન",
      "Home": "હોમ",
      "Category Details": "શ્રેણીની વિગતો",
      "My Cart": "મારું કાર્ટ",
      "Pay from Wallet": "વૉલેટથી ચૂકવણી કરો",
      "My Wallet": "મારું વૉલેટ",
      "Apply Coupon": "કૂપન લાગુ કરો",
      "Bill Summary": "બિલ સારાંશ",
      "Item Total (Incl. of taxes)": "મોટું મૂલ્ય (કર સહિત)",
      "Coupon Amount": "કૂપન રકમ",
      "Safety Fees": "સેફટી ફી",
      "Total Pay": "કુલ ચુકવણી",
      "Wallet Amount": "વૉલેટ રકમ",
      "Remove": "દૂર કરો",
      "Apply": "લાગુ કરો",
      "View All Coupons": "બધા કૂપન્સ જુઓ",
      "Any other requirements...": "અન્ય કોઈ જરૂરિયાતો...",
      "Mode of service :": "સેવાની રીત:",
      "Select Date Of Service :": "સેવાની તારીખ પસંદ કરો:",
      "Select Time Of Service :": "સેવાનો સમય પસંદ કરો:",
      "Select Address :": "સરનામું પસંદ કરો:",
      "+ Select Address": "+ સરનામું પસંદ કરો",
      "Continue": "ચાલુ રાખો",
      "Pickup": "પિકઅપ",
      "Walk In": "વોક-ઈન",
      "Coupon Code :": "કૂપન કોડ:",
      "Coupon Amount :": "કૂપન રકમ:",
      "Minimum Amount :": "લઘુત્તમ રકમ:",
      "Ex Date :": "સમાપ્તિ તારીખ:",
      "Add Address": "સરનામું ઉમેરો",
      "Name": "નામ",
      "Number": "નંબર",
      "House No": "મકાન નંબર",
      "Pincode": "પિનકોડ",
      "Landmark": "પહેચાન ચિહ્ન",
      "Eg:Home, Office, Other...": "દા.ત.: ઘર, ઓફિસ, અન્ય...",
      "Choose Address": "સરનામું પસંદ કરો",
      "+ Add Address": "+ સરનામું ઉમેરો",
      "Save address as": "સરનામું તરીકે સેવ કરો",
      "Total Balance": "કુલ બેલેન્સ",
      "Top Up": "ટોપ અપ",
      "Transaction": "લેનદેન",
      "No Any Transaction History !!": "કોઈ લેવડદેવડ ઇતિહાસ નથી !!",
      "Orders": "ઓર્ડર્સ",
      "You added": "તમે ઉમેર્યું",
      "items to orders": "વસ્તુઓ ઓર્ડરમાં",
      "SLOT SELECTED": "સ્લોટ પસંદ કરેલ",
      "STATUS": "સ્થિતિ",
      "No any bookings history !!": "કોઈ બુકિંગ ઇતિહાસ નથી !!",
      "Order Details": "ઓર્ડર વિગતો",
      "Order Status": "ઓર્ડરની સ્થિતિ",
      "Order Date": "ઓર્ડરની તારીખ",
      "Order Time": "ઓર્ડર સમય",
      "Payment Method": "ચુકવણીની રીત",
      "Online": "ઑનલાઇન",
      "Online & Wallet": "ઑનલાઇન અને વૉલેટ",
      "Cash & Wallet": "કેશ અને વૉલેટ",
      "Cash": "રોકડ",
      "Show More...": "વધુ જુઓ...",
      "Bill Summery": "બિલ સારાંશ",
      "Total": "કુલ",
      "Services": "સેવાઓ",
      "DETAILS": "વિગતો",
      "Eran": "કમાવો",
      "for Each Friend you refer": "દરેક મિત્ર માટે જેને તમે ભલામણ કરો",
      "Share the referral link with your friends": "તમારા મિત્રોને રેફરલ લિંક શેર કરો",
      "Friend get": "મિત્રને મળશે",
      "on first complete transaction": "પ્રથમ સંપૂર્ણ લેન્દેં પર",
      "You get": "તમને મળશે",
      "on your wallet": "તમારા વૉલેટમાં",
      "Text copied to clipboard !!": "ટેક્સ્ટ ક્લિપબોર્ડમાં નકલ થયો !!",
      "Please enter detaisl !!": "કૃપા કરીને વિગતો દાખલ કરો !!",
      "Logout successfuly": "લૉગઆઉટ સફળતા પૂર્વક થયું",
      "Please Enter Details !!": "કૃપા કરીને વિગતો દાખલ કરો !!",
      "Please Select Services !!": "કૃપા કરીને સેવાઓ પસંદ કરો !!",
      "Please Select Date !!": "કૃપા કરીને તારીખ પસંદ કરો !!",
      "Please Select Time !!": "કૃપા કરીને સમય પસંદ કરો !!",
      "Please Select Address !!": "કૃપા કરીને સરનામું પસંદ કરો !!",
      "Payment Faild !!": "ચુકવણી નિષ્ફળ ગઈ !!",
      "Please Enter Name !!": "કૃપા કરીને નામ દાખલ કરો !!",
      "Please Enter Email !!": "કૃપા કરીને ઈમેઈલ દાખલ કરો !!",
      "Please Enter Valid Email !!": "કૃપા કરીને માન્ય ઈમેઈલ દાખલ કરો !!",
      "Please Enter Password !!": "કૃપા કરીને પાસવર્ડ દાખલ કરો !!",
      "Accessorie": "એકસેસરી",
      "Show Less": "ઓછું બતાવો",
      "Show More": "વધુ બતાવો",
      "What's Included": "શું શામેલ છે",
      "Essential Services": "મૂળભૂત સેવાઓ",
      "Additional Service": "વધારાની સેવા",
      "Frequently Asked Questions": "અવારનવાર પૂછાતા પ્રશ્નો",
      "Book Date": "તારીખ બુક કરો",
      "Order id": "ઓર્ડર આઈડી",
      "Mode": "રીત",
      "Transaction id": "લેનદેન આઈડી",
      "Addition Note": "વધારાની નોંધ",
      "Store Address": "સ્ટોરનું સરનામું",
      "Phone Number": "ફોન નંબર",
      "Update": "અપડેટ કરો",
      "Enter your mobile number": "તમારું મોબાઇલ નંબર દાખલ કરો",
      "Please Enter Amount !!": "કૃપા કરીને રકમ દાખલ કરો !!",
      "Select Payment Methode !!": "ચુકવણી રીત પસંદ કરો !!",
      "Add Wallet Amount": "વૉલેટ રકમ ઉમેરો",
      "Select Payment Methode": "ચુકવણીની રીત પસંદ કરો",
      "Enter Amount": "રકમ દાખલ કરો",
      "Search Services": "સેવાઓ શોધો",
      "Accessories": "એકસેસરીઝ",
      "Search service": "સેવા શોધો",
      "Search Data !!": "ડેટા શોધો !!",
      "Page Not Found": "પેજ મળ્યું નથી",
      "Sorry, the page you are looking for does not exist.": "માફ કરશો, તમે શોધી રહ્યા છો તે પૃષ્ઠ અસ્તિત્વમાં નથી.",
      "To provide accurate services, please enable your location.": "ખરી સેવાઓ આપવા માટે, કૃપા કરીને તમારી લોકેશન ચાલુ કરો.",
      "Allow location access when prompted. If not prompted, enable it in your browser settings.": "જ્યારે પૂછવામાં આવે ત્યારે લોકેશન એક્સેસની મંજૂરી આપો. જો પૂછવામાં ન આવે તો તમારા બ્રાઉઝર સેટિંગ્સમાં તેને સક્રિય કરો.",
      "Refresh the page after enabling.": "સક્રિય કર્યા પછી પૃષ્ઠને રિફ્રેશ કરો.",
      "Enable Now": "હમણાં સક્રિય કરો",
      "Address": "સરનામું",
      "Quantity": "જથ્થો",
      "Extra Charge": "અતિરિક્ત ચાર્જ",
      "Total Extra Charge": "કુલ અતિરિક્ત ચાર્જ",
      "Charge Payment Id": "ચાર્જ પેમેન્ટ આઈડી",
      "Charge Transaction Id": "ચાર્જ ટ્રાન્ઝેક્શન આઈડી",
      "Charge Status": "ચાર્જની સ્થિતિ",
      "Pay Extra Charge": "અતિરિક્ત ચાર્જ ચૂકવો",
      "Item Total": "કુલ આઈટમ",
      "Unpaid": "અચૂકવેલ",
      "Paid": "ચૂકવેલ",
      "Service ID": "સેવા આઈડી",
      "Please select user !!": "કૃપા કરીને યુઝર પસંદ કરો !!",
      "Please write message !!": "કૃપા કરીને સંદેશ લખો !!",
      "Order History": "ઓર્ડર ઈતિહાસ",
      "User not found !!": "યુઝર મળ્યો નથી !!",
      "Select user": "યુઝર પસંદ કરો",
      "Chat list not found !!": "ચેટ યાદી મળી નથી !!",
      "Review": "સમીક્ષા",
      "Write message here...": "અહીં સંદેશ લખો...",
      "No service history found !!": "કોઈ સેવા ઈતિહાસ મળ્યો નથી !!",
      "Chat": "ચેટ",
      "Card number": "કાર્ડ નંબર",
      "Expiration date": "સમાપ્તિ તારીખ",
      "CVC": "CVC (સુરક્ષા કોડ)",
      "Added in": "ઉમેરાયું",
      "Carts": "કાર્ટ્સ"

    }
  },
  af: {
    translation: {
      "Welcome Back": "Welkom terug",
      "to": "by",
      "GoMechPro": "GoMechPro",
      "Hello there, login to continue": "Hallo daar, meld aan om voort te gaan",
      "Mobile Number": "Selfoonnommer",
      "Enter your mobile number...": "Voer jou selfoonnommer in...",
      "Password": "Wagwoord",
      "Remember me": "Onthou my",
      "Forget Password?": "Wagwoord vergeet?",
      "Sign In": "Teken in",
      "Continue as Guest": "Gaan voort as gas",
      "Sign Up": "Registreer",
      "Forgot Password?": "Wagwoord vergeet?",
      "Enter your mobile number account to": "Voer jou selfoonnommer in om",
      "reset your password.": "jou wagwoord terug te stel.",
      "Reset password": "Stel wagwoord terug",
      "Remember password?": "Onthou wagwoord?",
      "OTP Code Verification": "OTP‑kode verifikasie",
      "We have sent an OTP code to your mobile": "Ons het 'n OTP‑kode na jou selfoon gestuur",
      "number": "nommer",
      "Your OTP": "Jou OTP",
      "Confirm": "Bevestig",
      "Create New Password": "Skep nuwe wagwoord",
      "Create your new password": "Skep jou nuwe wagwoord",
      "Password strength": "Wagwoordkrag",
      "Confirm New Password": "Bevestig nuwe wagwoord",
      "Don't have and account?": "Het jy nie 'n rekening nie?",
      "Enter your password...": "Voer jou wagwoord in...",
      "input your password": "voer jou wagwoord in",
      "Please enter details !!": "Voer asseblief besonderhede in!!",
      "Please enter mobile number !!": "Voer asseblief selfoonnommer in!!",
      "OTP send successfully !!": "OTP suksesvol gestuur!!",
      "OTP is invalid !!": "OTP is ongeldig!!",
      "Passwoed not match !!": "Wagwoord stem nie ooreen nie!!",
      "Weak": "Swak",
      "Fair": "Matig",
      "Great ✅": "Goed ✅",
      "Very Great ✅": "Baie goed ✅",
      "Please enter valid email !!": "Voer asseblief 'n geldige e-pos in!!",
      "Signup Account": "Skep rekening",
      "Hello there, signup to continue": "Hallo daar, registreer om voort te gaan",
      "Full Name": "Volle naam",
      "Email Address": "E‑pos adres",
      "Referral code": "Verwysingskode",
      "I agree to the": "Ek stem in met",
      "Terms & Conditions & Privacy policy": "Ters & Voorwaardes & Privaatheidsbeleid",
      "Create Account": "Skep rekening",
      "I already have an account": "Ek het reeds 'n rekening",
      "Enter your full name...": "Voer jou volle naam in...",
      "Enter your email Address...": "Voer jou e‑pos adres in...",
      "Enter your referral code (Optional)": "Voer jou verwysingskode in (Opsioneel)",
      "Select Your Vehicle": "Kies jou voertuig",
      "Select Your Vehicle Brand": "Kies jou voertuig‑merk",
      "No brand found for": "Geen merk gevind vir",
      "this category": "hierdie kategorie",
      "Select Your": "Kies jou",
      "Model": "Model",
      "No model found for": "Geen model gevind vir",
      "this brand": "hierdie merk",
      "Menu": "Spyskaart",
      "Wallet": "Rits",
      "Edit Profile": "Wysig profiel",
      "My Order": "My bestelling",
      "Refer and Earn": "Verwys en verdien",
      "Language": "Taal",
      "Select Store": "Kies winkel",
      "No Stores found for": "Geen winkels gevind vir",
      "this category.": "hierdie kategorie.",
      "Select Your Vehicle Details": "Kies jou voertuigbesonderhede",
      "Register Number": "Registrasienommer",
      "Car Transmission Type": "Versnellingsbak‑tipe",
      "Car Fuel Type": "Brandstof‑tipe",
      "Petrol": "Petrol",
      "Diesel": "Diesel",
      "CNG": "CNG",
      "Add Vehicle": "Voeg voertuig by",
      "Manual": "Handmatig",
      "Automatic": "Outomaties",
      "Enter Your Register Number...": "Voer jou registrasienommer in...",
      "Select Vehicle": "Kies voertuig",
      "Add New Vehicle +": "Voeg nuwe voertuig by +",
      "Log Out": "Teken uit",
      "Categories": "Kategorieë",
      "Curated Custom Services": "Gekeurde persoonlike dienste",
      "Designer Service Combos": "Ontwerper dienskombinasies",
      "GoMechanic Guarantee": "GoMechanic waarborg",
      "OFF": "AFSLAG",
      "ADDED": "BYGEVOEG",
      "ADD": "BYVOEG",
      "Please Select All Details !!": "Kies asseblief alle besonderhede!!",
      "Basic Service": "Basiese diens",
      "Select Engine oil": "Kies enjinolie",
      "Free": "Gratis",
      "Boost Your Service": "Versterk jou diens",
      "For better performance & mileage": "Vir beter prestasie & brandstofverbruik",
      "ADD TO CART": "BYVOEG NA WINKELWA",
      "Service Added": "Diens bygevoeg",
      "VIEW CART": "KYK WINKELWA",
      "Edit": "Wysig",
      "Add Ons": "Byvoegings",
      "Home": "Tuis",
      "Category Details": "Kategoriebesonderhede",
      "My Cart": "My winkelwa",
      "Pay from Wallet": "Betaal vanaf rits",
      "My Wallet": "My rits",
      "Apply Coupon": "Pas koepon toe",
      "Bill Summary": "Rekenskopsamevatting",
      "Item Total (Incl. of taxes)": "Item totaal (belas inkluis)",
      "Coupon Amount": "Koopbewysbedrag",
      "Safety Fees": "Veiligheidsfooie",
      "Total Pay": "Totale betaling",
      "Wallet Amount": "Ritsbalans",
      "Remove": "Verwyder",
      "Apply": "Pas toe",
      "View All Coupons": "Bekyk alle koopbewyse",
      "Any other requirements...": "Enige ander vereistes...",
      "Mode of service :": "Dienstewaarde:",
      "Select Date Of Service :": "Kies diensdatum:",
      "Select Time Of Service :": "Kies diensuur:",
      "Select Address :": "Kies adres:",
      "+ Select Address": "+ Kies adres",
      "Continue": "Gaan voort",
      "Pickup": "Ophaling",
      "Walk In": "Lokaliseer",
      "Coupon Code :": "Koopbewyskode:",
      "Coupon Amount :": "Koopbewysbedrag:",
      "Minimum Amount :": "Minimum bedrag:",
      "Ex Date :": "Verval datum:",
      "Add Address": "Voeg adres by",
      "Name": "Naam",
      "Number": "Nommer",
      "House No": "Huisnr.",
      "Pincode": "Poskode",
      "Landmark": "Punt van herkenning",
      "Eg:Home, Office, Other...": "Bv: Huis, Kantoor, Ander...",
      "Choose Address": "Kies adres",
      "+ Add Address": "+ Voeg adres by",
      "Save address as": "Stoor adres as",
      "Total Balance": "Totale saldo",
      "Top Up": "Herlaai",
      "Transaction": "Transaksie",
      "No Any Transaction History !!": "Geen transaksiegeskiedenis nie!!",
      "Orders": "Bestellings",
      "You added": "Jy het bygevoeg",
      "items to orders": "items by bestellings",
      "SLOT SELECTED": "GAPTYP GEKIES",
      "STATUS": "STATUS",
      "No any bookings history !!": "Geen besprekinggeskiedenis nie!!",
      "Order Details": "Bestelling besonderhede",
      "Order Status": "Bestellingstatus",
      "Order Date": "Bestellingsdatum",
      "Order Time": "Bestellingstyd",
      "Payment Method": "Betaalmethode",
      "Online": "Aanlyn",
      "Online & Wallet": "Aanlyn & Rits",
      "Cash & Wallet": "Kontant & Rits",
      "Cash": "Kontant",
      "Show More...": "Wys meer...",
      "Bill Summery": "Rekenskap oorsig",
      "Total": "Totaal",
      "Services": "Dienste",
      "DETAILS": "BESONDERHEDE",
      "Eran": "Verdien",
      "for Each Friend you refer": "vir elke vriend wat jy verwys",
      "Share the referral link with your friends": "Deel die verwysingskoppel met jou vriende",
      "Friend get": "Vriend kry",
      "on first complete transaction": "by eerste volledige transaksie",
      "You get": "Jy kry",
      "on your wallet": "in jou rits",
      "Text copied to clipboard !!": "Teks na knipbord gekopieer!!",
      "Please enter detaisl !!": "Voer asseblief besonderhede in!!",
      "Logout successfuly": "Suksesvol afgemeld",
      "Please Enter Details !!": "Voer asseblief besonderhede in!!",
      "Please Select Services !!": "Kies asseblief dienste!!",
      "Please Select Date !!": "Kies asseblief datum!!",
      "Please Select Time !!": "Kies asseblief tyd!!",
      "Please Select Address !!": "Kies asseblief adres!!",
      "Payment Faild !!": "Betaling geMisluk!!",
      "Please Enter Name !!": "Voer asseblief naam in!!",
      "Please Enter Email !!": "Voer asseblief e-pos in!!",
      "Please Enter Valid Email !!": "Voer asseblief 'n geldige e-pos in!!",
      "Please Enter Password !!": "Voer asseblief wagwoord in!!",
      "Accessorie": "Bykomstigheid",
      "Show Less": "Wys minder",
      "Show More": "Wys meer",
      "What's Included": "Wat ingesluit is",
      "Essential Services": "Essensiële Dienste",
      "Additional Service": "Bykomende diens",
      "Frequently Asked Questions": "Gereelde vrae",
      "Book Date": "Besprekingsdatum",
      "Order id": "Bestelling-id",
      "Mode": "Modus",
      "Transaction id": "Transaksie-id",
      "Addition Note": "Bykomende nota",
      "Store Address": "Winkeladres",
      "Phone Number": "Telefoonnommer",
      "Update": "Opdateer",
      "Enter your mobile number": "Voer jou selfoonnommer in",
      "Please Enter Amount !!": "Voer asseblief bedrag in!!",
      "Select Payment Methode !!": "Kies asseblief betaalmetode!!",
      "Add Wallet Amount": "Voeg ritsbedrag by",
      "Select Payment Methode": "Kies betaalmetode",
      "Enter Amount": "Voer bedrag in",
      "Search Services": "Soek dienste",
      "Accessories": "Toebehore",
      "Search service": "Soek diens",
      "Search Data !!": "Soek data!!",
      "Page Not Found": "Bladsy nie gevind nie",
      "Sorry, the page you are looking for does not exist.": "Jammer, die bladsy waarna jy soek bestaan nie.",
      "To provide accurate services, please enable your location.": "Om akkurate dienste te lewer, aktiveer asseblief jou ligging.",
      "Allow location access when prompted. If not prompted, enable it in your browser settings.": "Laat toegang tot ligging toe wanneer gevra. As jy nie gevra word nie, aktiveer dit in jou blaaier se instellings.",
      "Refresh the page after enabling.": "Verfris die bladsy nadat dit geaktiveer is.",
      "Enable Now": "Aktiveer Nou",
      "Address": "Adres",
      "Quantity": "Hoeveelheid",
      "Extra Charge": "Ekstra Koste",
      "Total Extra Charge": "Totale Ekstra Koste",
      "Charge Payment Id": "Koste Betaling ID",
      "Charge Transaction Id": "Koste Transaksie ID",
      "Charge Status": "Kostestatus",
      "Pay Extra Charge": "Betaal Ekstra Koste",
      "Item Total": "Totaal van Item",
      "Unpaid": "Onbetaal",
      "Paid": "Betaal",
      "Service ID": "Diens ID",
      "Please select user !!": "Kies asseblief gebruiker !!",
      "Please write message !!": "Skryf asseblief 'n boodskap !!",
      "Order History": "Bestellingsgeskiedenis",
      "User not found !!": "Gebruiker nie gevind nie !!",
      "Select user": "Kies gebruiker",
      "Chat list not found !!": "Kletslis nie gevind nie !!",
      "Review": "Resensie",
      "Write message here...": "Skryf boodskap hier...",
      "No service history found !!": "Geen diensgeskiedenis gevind nie!!",
      "Chat": "Gesels",
      "Card number": "Kaartnommer",
      "Expiration date": "Vervaldatum",
      "CVC": "CVC",
      "Added in": "Bygevoeg in",
      "Carts": "Trollies"

    }
  },
  be: {
    translation: {
      "Welcome Back": "স্বাগতম ফিরে",
      "to": "থেকে",
      "GoMechPro": "GoMechPro",
      "Hello there, login to continue": "হ্যালো, অব্যাহত রাখতে লগইন করুন",
      "Mobile Number": "মোবাইল নম্বর",
      "Enter your mobile number...": "আপনার মোবাইল নম্বর লিখুন...",
      "Password": "পাসওয়ার্ড",
      "Remember me": "আমাকে মনে রাখুন",
      "Forget Password?": "পাসওয়ার্ড ভুলে গেছেন?",
      "Sign In": "প্রবেশ করুন",
      "Continue as Guest": "অতিথি হিসেবে চালিয়ে যান",
      "Sign Up": "নিবন্ধন করুন",
      "Forgot Password?": "পাসওয়ার্ড ভুলে গেছেন?",
      "Enter your mobile number account to": "আপনার মোবাইল নম্বর লিখে",
      "reset your password.": "পাসওয়ার্ড রিসেট করুন।",
      "Reset password": "পাসওয়ার্ড পুনরায় সেট করুন",
      "Remember password?": "পাসওয়ার্ড মনে আছে?",
      "OTP Code Verification": "ওটিপি কোড যাচাইকরণ",
      "We have sent an OTP code to your mobile": "আমরা আপনার মোবাইলে একটি ওটিপি কোড পাঠিয়েছি",
      "number": "নম্বর",
      "Your OTP": "আপনার ওটিপি",
      "Confirm": "নিশ্চিত করুন",
      "Create New Password": "নতুন পাসওয়ার্ড তৈরি করুন",
      "Create your new password": "আপনার নতুন পাসওয়ার্ড তৈরি করুন",
      "Password strength": "পাসওয়ার্ডের শক্তি",
      "Confirm New Password": "নতুন পাসওয়ার্ড নিশ্চিত করুন",
      "Don't have and account?": "একাউন্ট নেই?",
      "Enter your password...": "আপনার পাসওয়ার্ড লিখুন...",
      "input your password": "আপনার পাসওয়ার্ড লিখুন",
      "Please enter details !!": "অনুগ্রহ করে তথ্যাদি লিখুন!!",
      "Please enter mobile number !!": "অনুগ্রহ করে মোবাইল নম্বর লিখুন!!",
      "OTP send successfully !!": "ওটিপি সফলভাবে পাঠানো হয়েছে!!",
      "OTP is invalid !!": "ওটিপি অবৈধ!!",
      "Passwoed not match !!": "পাসওয়ার্ড মিলে না!!",
      "Weak": "দুর্বল",
      "Fair": "মাঝামাঝি",
      "Great ✅": "চমৎকার ✅",
      "Very Great ✅": "অত্যন্ত চমৎকার ✅",
      "Please enter valid email !!": "অনুগ্রহ করে বৈধ ইমেল লিখুন!!",
      "Signup Account": "একাউন্ট নিবন্ধন করুন",
      "Hello there, signup to continue": "হ্যালো, চালিয়ে যেতে নিবন্ধন করুন",
      "Full Name": "পূর্ণ নাম",
      "Email Address": "ইমেল ঠিকানা",
      "Referral code": "রেফারেল কোড",
      "I agree to the": "আমি একমত",
      "Terms & Conditions & Privacy policy": "শর্তাবলী ও গোপনীয়তা নীতি",
      "Create Account": "একাউন্ট তৈরি করুন",
      "I already have an account": "আমার ইতিমধ্যে একটি একাউন্ট রয়েছে",
      "Enter your full name...": "আপনার পূর্ণ নাম লিখুন...",
      "Enter your email Address...": "আপনার ইমেল ঠিকানা লিখুন...",
      "Enter your referral code (Optional)": "আপনার রেফারেল কোড লিখুন (ঐচ্ছিক)",
      "Select Your Vehicle": "আপনার যানবাহন নির্বাচন করুন",
      "Select Your Vehicle Brand": "আপনার যানবাহনের ব্র্যান্ড নির্বাচন করুন",
      "No brand found for": "এই ক্যাটেগরির জন্য কোনো ব্র্যান্ড নেই",
      "this category": "এই ক্যাটেগরিতে",
      "Select Your": "নির্বাচন করুন",
      "Model": "মডেল",
      "No model found for": "এই ব্র্যান্ডের জন্য কোন মডেল নেই",
      "this brand": "এই ব্র্যান্ডে",
      "Menu": "মেনু",
      "Wallet": "ওয়ালেট",
      "Edit Profile": "প্রোফাইল সম্পাদনা করুন",
      "My Order": "আমার অর্ডার",
      "Refer and Earn": "রেফার করুন ও উপার্জন করুন",
      "Language": "ভাষা",
      "Select Store": "স্টোর নির্বাচন করুন",
      "No Stores found for": "এই ক্যাটেগরির জন্য কোনো স্টোর নেই",
      "this category.": "এই ক্যাটেগরিতে।",
      "Select Your Vehicle Details": "আপনার যানবাহনের বিস্তারিত নির্বাচন করুন",
      "Register Number": "নিবন্ধন নম্বর",
      "Car Transmission Type": "গাড়ির ট্রান্সমিশন ধরন",
      "Car Fuel Type": "গাড়ির ইন্ধন ধরন",
      "Petrol": "পেট্রোল",
      "Diesel": "ডিজেল",
      "CNG": "সিএনজি",
      "Add Vehicle": "গাড়ি যোগ করুন",
      "Manual": "ম্যানুয়াল",
      "Automatic": "অটোমেটিক",
      "Enter Your Register Number...": "আপনার নিবন্ধন নম্বর লিখুন...",
      "Select Vehicle": "গাড়ি নির্বাচন করুন",
      "Add New Vehicle +": "নতুন গাড়ি যোগ করুন +",
      "Log Out": "লগ আউট",
      "Categories": "ক্যাটেগরিসমূহ",
      "Curated Custom Services": "নির্বাচিত কাস্টম সেবা",
      "Designer Service Combos": "ডিজাইনার সার্ভিস কম্বো",
      "GoMechanic Guarantee": "GoMechanic গ্যারান্টি",
      "OFF": "ছাড়",
      "ADDED": "যোগ হয়েছে",
      "ADD": "যোগ করুন",
      "Please Select All Details !!": "অনুগ্রহ করে সমস্ত তথ্য নির্বাচন করুন!!",
      "Basic Service": "বেসিক সেবা",
      "Select Engine oil": "ইঞ্জিন অয়েল নির্বাচন করুন",
      "Free": "ফ্রি",
      "Boost Your Service": "আপনার সেবা উন্নত করুন",
      "For better performance & mileage": "ভাল পারফরম্যান্স ও মাইলেজের জন্য",
      "ADD TO CART": "কার্টে যোগ করুন",
      "Service Added": "সেবা যোগ করা হয়েছে",
      "VIEW CART": "কার্ট দেখুন",
      "Edit": "সম্পাদনা করুন",
      "Add Ons": "অ্যাড-অন",
      "Home": "হোম",
      "Category Details": "ক্যাটেগরি বিবরণ",
      "My Cart": "আমার কার্ট",
      "Pay from Wallet": "ওয়ালেট থেকে পরিশোধ করুন",
      "My Wallet": "আমার ওয়ালেট",
      "Apply Coupon": "কুপন প্রয়োগ করুন",
      "Bill Summary": "বিলের সারাংশ",
      "Item Total (Incl. of taxes)": "মোট পণ্য (করসহ)",
      "Coupon Amount": "কুপন পরিমাণ",
      "Safety Fees": "নিরাপত্তা ফি",
      "Total Pay": "মোট পরিশোধ",
      "Wallet Amount": "ওয়ালেট পরিমাণ",
      "Remove": "বাদ দিন",
      "Apply": "প্রয়োগ করুন",
      "View All Coupons": "সমস্ত কুপন দেখুন",
      "Any other requirements...": "অন্যান্য কোনো চাহিদা...",
      "Mode of service :": "সেবার ধরন:",
      "Select Date Of Service :": "সেবার তারিখ নির্বাচন করুন:",
      "Select Time Of Service :": "সেবার সময় নির্বাচন করুন:",
      "Select Address :": "ঠিকানা নির্বাচন করুন:",
      "+ Select Address": "+ ঠিকানা নির্বাচন করুন",
      "Continue": "আগে যান",
      "Pickup": "নেওয়ার স্থান",
      "Walk In": "আগমনের ভিত্তিতে",
      "Coupon Code :": "কুপন কোড:",
      "Coupon Amount :": "কুপন পরিমাণ:",
      "Minimum Amount :": "ন্যূনতম পরিমাণ:",
      "Ex Date :": "সমাপ্তির তারিখ:",
      "Add Address": "ঠিকানা যোগ করুন",
      "Name": "নাম",
      "Number": "সংখ্যা",
      "House No": "বাসা নম্বর",
      "Pincode": "পিনকোড",
      "Landmark": "প্ৰতীক",
      "Eg:Home, Office, Other...": "যেমনঃ বাড়ি, অফিস, অন্যান্য...",
      "Choose Address": "ঠিকানা বাছুন",
      "+ Add Address": "+ ঠিকানা যোগ করুন",
      "Save address as": "ঠিকানাটি সংরক্ষণ করুন",
      "Total Balance": "মোট বিলেন্স",
      "Top Up": "রিচার্জ করুন",
      "Transaction": "লেনদেন",
      "No Any Transaction History !!": "কোনো লেনদেন ইতিহাস নেই!!",
      "Orders": "অর্ডারসমূহ",
      "You added": "আপনি যোগ করেছেন",
      "items to orders": "পণ্য অর্ডারে",
      "SLOT SELECTED": "স্লট নির্বাচন করা হয়েছে",
      "STATUS": "অবস্থা",
      "No any bookings history !!": "কোনো বুকিং ইতিহাস নেই!!",
      "Order Details": "অর্ডারের বিস্তারিত",
      "Order Status": "অর্ডারের অবস্থা",
      "Order Date": "অর্ডারের তারিখ",
      "Order Time": "অর্ডারের সময়",
      "Payment Method": "পরিশোধ পদ্ধতি",
      "Online": "অনলাইনে",
      "Online & Wallet": "অনলাইনে ও ওয়ালেটে",
      "Cash & Wallet": "নগদ ও ওয়ালেটে",
      "Cash": "নগদ",
      "Show More...": "আরো দেখুন...",
      "Bill Summery": "বিল সারসংক্ষেপ",
      "Total": "মোট",
      "Services": "সেবা সমূহ",
      "DETAILS": "বিস্তারিত",
      "Eran": "আয় করুন",
      "for Each Friend you refer": "প্রত্যেক বন্ধু যা আপনি রেফার করবেন",
      "Share the referral link with your friends": "রেফারেল লিঙ্ক আপনার বন্ধুদের শেয়ার করুন",
      "Friend get": "বন্ধু পেলো",
      "on first complete transaction": "প্রথম সম্পূর্ণ লেনদেনে",
      "You get": "আপনি পেলেন",
      "on your wallet": "আপনার ওয়ালেটে",
      "Text copied to clipboard !!": "টেক্সট ক্লিপবোর্ডে কপি করা হয়েছে!!",
      "Please enter detaisl !!": "অনুগ্রহ করে বিস্তারিত লিখুন!!",
      "Logout successfuly": "সফলভাবে লগআউট হয়েছে",
      "Please Enter Details !!": "অনুগ্রহ করে বিস্তারিত লিখুন!!",
      "Please Select Services !!": "অনুগ্রহ করে সেবা নির্বাচন করুন!!",
      "Please Select Date !!": "অনুগ্রহ করে তারিখ নির্বাচন করুন!!",
      "Please Select Time !!": "অনুগ্রহ করে সময় নির্বাচন করুন!!",
      "Please Select Address !!": "অনুগ্রহ করে ঠিকানা নির্বাচন করুন!!",
      "Payment Faild !!": "পরিশোধ ব্যর্থ হয়েছে!!",
      "Please Enter Name !!": "অনুগ্রহ করে নাম লিখুন!!",
      "Please Enter Email !!": "অনুগ্রহ করে ইমেইল লিখুন!!",
      "Please Enter Valid Email !!": "অনুগ্রহ করে বৈধ ইমেইল লিখুন!!",
      "Please Enter Password !!": "অনুগ্রহ করে পাসওয়ার্ড লিখুন!!",
      "Accessorie": "অ্যাকসেসরি",
      "Show Less": "কম দেখাও",
      "Show More": "আরো দেখাও",
      "What's Included": "ক্যাটেগরিতে টি ঢুকেছে",
      "Essential Services": "নগন্য সেবা",
      "Additional Service": "অতিরিক্ত সেবা",
      "Frequently Asked Questions": "প্রায়শই জিজ্ঞাসিত প্রশ্ন",
      "Book Date": "তারিখ বুক করুন",
      "Order id": "অর্ডার আইডি",
      "Mode": "মোড",
      "Transaction id": "লেনদেন আইডি",
      "Addition Note": "অতিরিক্ত মন্তব্য",
      "Store Address": "স্টোর ঠিকানা",
      "Phone Number": "ফোন নম্বর",
      "Update": "আপডেট",
      "Enter your mobile number": "আপনার মোবাইল নম্বর লিখুন",
      "Please Enter Amount !!": "অনুগ্রহ করে পরিমাণ লিখুন!!",
      "Select Payment Methode !!": "অনুগ্রহ করে পরিশোধ পদ্ধতি নির্বাচন করুন!!",
      "Add Wallet Amount": "ওয়ালেটে পরিমাণ যোগ করুন",
      "Select Payment Methode": "পরিশোধ পদ্ধতি নির্বাচন করুন",
      "Enter Amount": "পরিমাণ লিখুন",
      "Search Services": "সেবা খুঁজুন",
      "Accessories": "অ্যাকসেসরিজ",
      "Search service": "সেবা খুঁজুন",
      "Search Data !!": "তথ্য খুঁজুন!!",
      "Page Not Found": "পৃষ্ঠা পাওয়া যায়নি",
      "Sorry, the page you are looking for does not exist.": "দুঃখিত, আপনি যে পৃষ্ঠা খুঁজছেন তা বিদ্যমান নেই।",
      "To provide accurate services, please enable your location.": "সঠিক পরিষেবা দিতে, অনুগ্রহ করে আপনার অবস্থান চালু করুন।",
      "Allow location access when prompted. If not prompted, enable it in your browser settings.": "প্রম্পট করা হলে অবস্থান অ্যাক্সেসের অনুমতি দিন। যদি না চাওয়া হয়, তাহলে ব্রাউজারের সেটিংসে এটি চালু করুন।",
      "Refresh the page after enabling.": "সক্ষম করার পর পৃষ্ঠাটি রিফ্রেশ করুন।",
      "Enable Now": "এখন সক্ষম করুন",
      "Address": "ঠিকানা",
      "Quantity": "পরিমাণ",
      "Extra Charge": "অতিরিক্ত চার্জ",
      "Total Extra Charge": "মোট অতিরিক্ত চার্জ",
      "Charge Payment Id": "চার্জ পেমেন্ট আইডি",
      "Charge Transaction Id": "চার্জ লেনদেন আইডি",
      "Charge Status": "চার্জের অবস্থা",
      "Pay Extra Charge": "অতিরিক্ত চার্জ পরিশোধ করুন",
      "Item Total": "আইটেম মোট",
      "Unpaid": "অপরিশোধিত",
      "Paid": "পরিশোধিত",
      "Service ID": "সার্ভিস আইডি",
      "Please select user !!": "অনুগ্রহ করে ব্যবহারকারী নির্বাচন করুন !!",
      "Please write message !!": "অনুগ্রহ করে বার্তা লিখুন !!",
      "Order History": "অর্ডার ইতিহাস",
      "User not found !!": "ব্যবহারকারী খুঁজে পাওয়া যায়নি !!",
      "Select user": "ব্যবহারকারী নির্বাচন করুন",
      "Chat list not found !!": "চ্যাট তালিকা পাওয়া যায়নি !!",
      "Review": "রিভিউ",
      "Write message here...": "এখানে বার্তা লিখুন...",
      "No service history found !!": "কোনো সার্ভিস ইতিহাস পাওয়া যায়নি!!",
      "Chat": "চ্যাট",
      "Card number": "কার্ড নম্বর",
      "Expiration date": "মেয়াদ শেষের তারিখ",
      "CVC": "সিভিসি (CVC)",
      "Added in": "যোগ করা হয়েছে",
      "Carts": "কার্টসমূহ"
    }
  },
  in: {
    translation: {
      "Welcome Back": "Selamat Datang Kembali",
      "to": "ke",
      "GoMechPro": "GoMechPro",
      "Hello there, login to continue": "Halo, masuk untuk melanjutkan",
      "Mobile Number": "Nomor Ponsel",
      "Enter your mobile number...": "Masukkan nomor ponsel Anda...",
      "Password": "Kata Sandi",
      "Remember me": "Ingat saya",
      "Forget Password?": "Lupa Kata Sandi?",
      "Sign In": "Masuk",
      "Continue as Guest": "Lanjutkan sebagai Tamu",
      "Sign Up": "Daftar",
      "Forgot Password?": "Lupa Kata Sandi?",
      "Enter your mobile number account to": "Masukkan nomor ponsel untuk",
      "reset your password.": "mengatur ulang kata sandi Anda.",
      "Reset password": "Atur ulang kata sandi",
      "Remember password?": "Ingat kata sandi?",
      "OTP Code Verification": "Verifikasi Kode OTP",
      "We have sent an OTP code to your mobile": "Kami telah mengirim kode OTP ke nomor ponsel Anda",
      "number": "nomor",
      "Your OTP": "Kode OTP Anda",
      "Confirm": "Konfirmasi",
      "Create New Password": "Buat Kata Sandi Baru",
      "Create your new password": "Buat kata sandi baru Anda",
      "Password strength": "Kekuatan kata sandi",
      "Confirm New Password": "Konfirmasi Kata Sandi Baru",
      "Don't have and account?": "Belum punya akun?",
      "Enter your password...": "Masukkan kata sandi Anda...",
      "input your password": "masukkan kata sandi Anda",
      "Please enter details !!": "Harap isi detailnya !!",
      "Please enter mobile number !!": "Harap masukkan nomor ponsel !!",
      "OTP send successfully !!": "OTP berhasil dikirim !!",
      "OTP is invalid !!": "OTP tidak valid !!",
      "Passwoed not match !!": "Kata sandi tidak cocok !!",
      "Weak": "Lemah",
      "Fair": "Cukup",
      "Great ✅": "Bagus ✅",
      "Very Great ✅": "Sangat Bagus ✅",
      "Please enter valid email !!": "Harap masukkan email yang valid !!",
      "Signup Account": "Daftar Akun",
      "Hello there, signup to continue": "Halo, daftar untuk melanjutkan",
      "Full Name": "Nama Lengkap",
      "Email Address": "Alamat Email",
      "Referral code": "Kode Referensi",
      "I agree to the": "Saya setuju dengan",
      "Terms & Conditions & Privacy policy": "Syarat & Ketentuan & Kebijakan Privasi",
      "Create Account": "Buat Akun",
      "I already have an account": "Saya sudah punya akun",
      "Enter your full name...": "Masukkan nama lengkap Anda...",
      "Enter your email Address...": "Masukkan alamat email Anda...",
      "Enter your referral code (Optional)": "Masukkan kode referensi Anda (Opsional)",
      "Select Your Vehicle": "Pilih Kendaraan Anda",
      "Select Your Vehicle Brand": "Pilih Merek Kendaraan Anda",
      "No brand found for": "Merek tidak ditemukan untuk",
      "this category": "kategori ini",
      "Select Your": "Pilih",
      "Model": "Model",
      "No model found for": "Model tidak ditemukan untuk",
      "this brand": "merek ini",
      "Menu": "Menu",
      "Wallet": "Dompet",
      "Edit Profile": "Ubah Profil",
      "My Order": "Pesanan Saya",
      "Refer and Earn": "Referensi dan Dapatkan",
      "Language": "Bahasa",
      "Select Store": "Pilih Toko",
      "No Stores found for": "Toko tidak ditemukan untuk",
      "this category.": "kategori ini.",
      "Select Your Vehicle Details": "Pilih Detail Kendaraan Anda",
      "Register Number": "Nomor Registrasi",
      "Car Transmission Type": "Jenis Transmisi Mobil",
      "Car Fuel Type": "Jenis Bahan Bakar Mobil",
      "Petrol": "Bensin",
      "Diesel": "Diesel",
      "CNG": "CNG",
      "Add Vehicle": "Tambah Kendaraan",
      "Manual": "Manual",
      "Automatic": "Otomatis",
      "Enter Your Register Number...": "Masukkan Nomor Registrasi Anda...",
      "Select Vehicle": "Pilih Kendaraan",
      "Add New Vehicle +": "Tambah Kendaraan Baru +",
      "Log Out": "Keluar",
      "Categories": "Kategori",
      "Curated Custom Services": "Layanan Khusus Terpilih",
      "Designer Service Combos": "Paket Layanan Desainer",
      "GoMechanic Guarantee": "Jaminan GoMechanic",
      "OFF": "OFF",
      "ADDED": "DITAMBAHKAN",
      "ADD": "TAMBAH",
      "Please Select All Details !!": "Harap Pilih Semua Detail !!",
      "Basic Service": "Layanan Dasar",
      "Select Engine oil": "Pilih Oli Mesin",
      "Free": "Gratis",
      "Boost Your Service": "Tingkatkan Layanan Anda",
      "For better performance & mileage": "Untuk performa & jarak tempuh lebih baik",
      "ADD TO CART": "TAMBAH KE KERANJANG",
      "Service Added": "Layanan Ditambahkan",
      "VIEW CART": "LIHAT KERANJANG",
      "Edit": "Ubah",
      "Add Ons": "Tambahan",
      "Home": "Beranda",
      "Category Details": "Detail Kategori",
      "My Cart": "Keranjang Saya",
      "Pay from Wallet": "Bayar dari Dompet",
      "My Wallet": "Dompet Saya",
      "Apply Coupon": "Terapkan Kupon",
      "Bill Summary": "Ringkasan Tagihan",
      "Item Total (Incl. of taxes)": "Total Item (Termasuk pajak)",
      "Coupon Amount": "Jumlah Kupon",
      "Safety Fees": "Biaya Keamanan",
      "Total Pay": "Total Bayar",
      "Wallet Amount": "Jumlah Dompet",
      "Remove": "Hapus",
      "Apply": "Terapkan",
      "View All Coupons": "Lihat Semua Kupon",
      "Any other requirements...": "Persyaratan lain...",
      "Mode of service :": "Mode layanan :",
      "Select Date Of Service :": "Pilih Tanggal Layanan :",
      "Select Time Of Service :": "Pilih Waktu Layanan :",
      "Select Address :": "Pilih Alamat :",
      "+ Select Address": "+ Pilih Alamat",
      "Continue": "Lanjutkan",
      "Pickup": "Ambil",
      "Walk In": "Datang Langsung",
      "Coupon Code :": "Kode Kupon :",
      "Coupon Amount :": "Jumlah Kupon :",
      "Minimum Amount :": "Jumlah Minimum :",
      "Ex Date :": "Tanggal Kadaluarsa :",
      "Add Address": "Tambah Alamat",
      "Name": "Nama",
      "Number": "Nomor",
      "House No": "No Rumah",
      "Pincode": "Kode Pos",
      "Landmark": "Tanda Landmark",
      "Eg:Home, Office, Other...": "Misal: Rumah, Kantor, Lainnya...",
      "Choose Address": "Pilih Alamat",
      "+ Add Address": "+ Tambah Alamat",
      "Save address as": "Simpan alamat sebagai",
      "Total Balance": "Total Saldo",
      "Top Up": "Isi Ulang",
      "Transaction": "Transaksi",
      "No Any Transaction History !!": "Tidak ada riwayat transaksi !!",
      "Orders": "Pesanan",
      "You added": "Anda menambahkan",
      "items to orders": "item ke pesanan",
      "SLOT SELECTED": "SLOT TERPILIH",
      "STATUS": "STATUS",
      "No any bookings history !!": "Tidak ada riwayat pemesanan !!",
      "Order Details": "Detail Pesanan",
      "Order Status": "Status Pesanan",
      "Order Date": "Tanggal Pesanan",
      "Order Time": "Waktu Pesanan",
      "Payment Method": "Metode Pembayaran",
      "Online": "Online",
      "Online & Wallet": "Online & Dompet",
      "Cash & Wallet": "Tunai & Dompet",
      "Cash": "Tunai",
      "Show More...": "Tampilkan Lebih...",
      "Bill Summery": "Ringkasan Tagihan",
      "Total": "Total",
      "Services": "Layanan",
      "DETAILS": "DETAIL",
      "Eran": "Dapatkan",
      "for Each Friend you refer": "untuk setiap teman yang Anda rekomendasikan",
      "Share the referral link with your friends": "Bagikan tautan referensi ke teman Anda",
      "Friend get": "Teman mendapatkan",
      "on first complete transaction": "pada transaksi lengkap pertama",
      "You get": "Anda mendapatkan",
      "on your wallet": "di dompet Anda",
      "Text copied to clipboard !!": "Teks berhasil disalin ke clipboard !!",
      "Please enter detaisl !!": "Harap masukkan detail !!",
      "Logout successfuly": "Berhasil keluar",
      "Please Enter Details !!": "Harap masukkan detail !!",
      "Please Select Services !!": "Harap pilih layanan !!",
      "Please Select Date !!": "Harap pilih tanggal !!",
      "Please Select Time !!": "Harap pilih waktu !!",
      "Please Select Address !!": "Harap pilih alamat !!",
      "Payment Faild !!": "Pembayaran gagal !!",
      "Please Enter Name !!": "Harap masukkan nama !!",
      "Please Enter Email !!": "Harap masukkan email !!",
      "Please Enter Valid Email !!": "Harap masukkan email yang valid !!",
      "Please Enter Password !!": "Harap masukkan kata sandi !!",
      "Accessorie": "Aksesoris",
      "Show Less": "Tampilkan Sedikit",
      "Show More": "Tampilkan Lebih",
      "What's Included": "Apa yang Termasuk",
      "Essential Services": "Layanan Penting",
      "Additional Service": "Layanan Tambahan",
      "Frequently Asked Questions": "Pertanyaan yang Sering Diajukan",
      "Book Date": "Tanggal Pesan",
      "Order id": "ID Pesanan",
      "Mode": "Mode",
      "Transaction id": "ID Transaksi",
      "Addition Note": "Catatan Tambahan",
      "Store Address": "Alamat Toko",
      "Phone Number": "Nomor Telepon",
      "Update": "Perbarui",
      "Enter your mobile number": "Masukkan nomor ponsel Anda",
      "Please Enter Amount !!": "Harap masukkan jumlah !!",
      "Select Payment Methode !!": "Harap pilih metode pembayaran !!",
      "Add Wallet Amount": "Tambah Jumlah Dompet",
      "Select Payment Methode": "Pilih Metode Pembayaran",
      "Enter Amount": "Masukkan Jumlah",
      "Search Services": "Cari Layanan",
      "Accessories": "Aksesoris",
      "Search service": "Cari layanan",
      "Search Data !!": "Cari Data !!",
      "Page Not Found": "Halaman Tidak Ditemukan",
      "Sorry, the page you are looking for does not exist.": "Maaf, halaman yang Anda cari tidak ada.",
      "To provide accurate services, please enable your location.": "Untuk memberikan layanan yang akurat, silakan aktifkan lokasi Anda.",
      "Allow location access when prompted. If not prompted, enable it in your browser settings.": "Izinkan akses lokasi saat diminta. Jika tidak diminta, aktifkan melalui pengaturan browser Anda.",
      "Refresh the page after enabling.": "Segarkan halaman setelah mengaktifkan.",
      "Enable Now": "Aktifkan Sekarang",
      "Address": "Alamat",
      "Quantity": "Kuantitas",
      "Extra Charge": "Biaya Tambahan",
      "Total Extra Charge": "Total Biaya Tambahan",
      "Charge Payment Id": "ID Pembayaran Biaya",
      "Charge Transaction Id": "ID Transaksi Biaya",
      "Charge Status": "Status Biaya",
      "Pay Extra Charge": "Bayar Biaya Tambahan",
      "Item Total": "Total Barang",
      "Unpaid": "Belum Dibayar",
      "Paid": "Sudah Dibayar",
      "Service ID": "ID Layanan",
      "Please select user !!": "Silakan pilih pengguna !!",
      "Please write message !!": "Silakan tulis pesan !!",
      "Order History": "Riwayat Pesanan",
      "User not found !!": "Pengguna tidak ditemukan !!",
      "Select user": "Pilih pengguna",
      "Chat list not found !!": "Daftar obrolan tidak ditemukan !!",
      "Review": "Ulasan",
      "Write message here...": "Tulis pesan di sini...",
      "No service history found !!": "Riwayat layanan tidak ditemukan!!",
      "Chat": "Obrolan",
      "Card number": "Nomor kartu",
      "Expiration date": "Tanggal kedaluwarsa",
      "CVC": "CVC",
      "Added in": "Ditambahkan pada",
      "Carts": "Keranjang"
    }
  },
};

const savedLanguage = secureLocalStorage.getItem('I18') || 'en';

i18n.use(initReactI18next).init({
  resources,
  lng: savedLanguage,
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false
  }
});

export default i18n;